/* ─── Lineup v2 — Festival Wishlist Engine ─── */
/* IIFE · no build step · localStorage-based · multi-day support */
(function () {
  'use strict';

  // ─── BAIL ───
  if (typeof window === 'undefined') return;

  // ─── FUSE.JS v7.0.0 (MIT) — inline fuzzy search ───
  var Fuse=(function(){"use strict";function e(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function t(t){for(var n=1;n<arguments.length;n++){var r=null!=arguments[n]?arguments[n]:{};n%2?e(Object(r),!0).forEach((function(e){c(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):e(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}function n(e){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(e)}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,v(r.key),r)}}function o(e,t,n){return t&&i(e.prototype,t),n&&i(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}function c(e,t,n){return(t=v(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&u(e,t)}function s(e){return s=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},s(e)}function u(e,t){return u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},u(e,t)}function h(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function l(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=s(e);if(t){var i=s(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return h(this,n)}}function f(e){return function(e){if(Array.isArray(e))return d(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(e){if("string"==typeof e)return d(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?d(e,t):void 0}}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function d(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function v(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}function g(e){return Array.isArray?Array.isArray(e):"[object Array]"===S(e)}var y=1/0;function p(e){return null==e?"":function(e){if("string"==typeof e)return e;var t=e+"";return"0"==t&&1/e==-y?"-0":t}(e)}function m(e){return"string"==typeof e}function k(e){return"number"==typeof e}function M(e){return!0===e||!1===e||function(e){return b(e)&&null!==e}(e)&&"[object Boolean]"==S(e)}function b(e){return"object"===n(e)}function x(e){return null!=e}function w(e){return!e.trim().length}function S(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":Object.prototype.toString.call(e)}var L=function(e){return"Missing ".concat(e," property in key")},_=function(e){return"Property 'weight' in key '".concat(e,"' must be a positive integer")},O=Object.prototype.hasOwnProperty,j=function(){function e(t){var n=this;r(this,e),this._keys=[],this._keyMap={};var i=0;t.forEach((function(e){var t=A(e);n._keys.push(t),n._keyMap[t.id]=t,i+=t.weight})),this._keys.forEach((function(e){e.weight/=i}))}return o(e,[{key:"get",value:function(e){return this._keyMap[e]}},{key:"keys",value:function(){return this._keys}},{key:"toJSON",value:function(){return JSON.stringify(this._keys)}}]),e}();function A(e){var t=null,n=null,r=null,i=1,o=null;if(m(e)||g(e))r=e,t=I(e),n=C(e);else{if(!O.call(e,"name"))throw new Error(L("name"));var c=e.name;if(r=c,O.call(e,"weight")&&(i=e.weight)<=0)throw new Error(_(c));t=I(c),n=C(c),o=e.getFn}return{path:t,id:n,weight:i,src:r,getFn:o}}function I(e){return g(e)?e:e.split(".")}function C(e){return g(e)?e.join("."):e}var E={useExtendedSearch:!1,getFn:function(e,t){var n=[],r=!1;return function e(t,i,o){if(x(t))if(i[o]){var c=t[i[o]];if(!x(c))return;if(o===i.length-1&&(m(c)||k(c)||M(c)))n.push(p(c));else if(g(c)){r=!0;for(var a=0,s=c.length;a<s;a+=1)e(c[a],i,o+1)}else i.length&&e(c,i,o+1)}else n.push(t)}(e,m(t)?t.split("."):t,0),r?n:n[0]},ignoreLocation:!1,ignoreFieldNorm:!1,fieldNormWeight:1},$=t(t(t(t({},{isCaseSensitive:!1,includeScore:!1,keys:[],shouldSort:!0,sortFn:function(e,t){return e.score===t.score?e.idx<t.idx?-1:1:e.score<t.score?-1:1}}),{includeMatches:!1,findAllMatches:!1,minMatchCharLength:1}),{location:0,threshold:.6,distance:100}),E),F=/[^ ]+/g,R=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.getFn,i=void 0===n?$.getFn:n,o=t.fieldNormWeight,c=void 0===o?$.fieldNormWeight:o;r(this,e),this.norm=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:3,n=new Map,r=Math.pow(10,t);return{get:function(t){var i=t.match(F).length;if(n.has(i))return n.get(i);var o=1/Math.pow(i,.5*e),c=parseFloat(Math.round(o*r)/r);return n.set(i,c),c},clear:function(){n.clear()}}}(c,3),this.getFn=i,this.isCreated=!1,this.setIndexRecords()}return o(e,[{key:"setSources",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];this.docs=e}},{key:"setIndexRecords",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];this.records=e}},{key:"setKeys",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];this.keys=t,this._keysMap={},t.forEach((function(t,n){e._keysMap[t.id]=n}))}},{key:"create",value:function(){var e=this;!this.isCreated&&this.docs.length&&(this.isCreated=!0,m(this.docs[0])?this.docs.forEach((function(t,n){e._addString(t,n)})):this.docs.forEach((function(t,n){e._addObject(t,n)})),this.norm.clear())}},{key:"add",value:function(e){var t=this.size();m(e)?this._addString(e,t):this._addObject(e,t)}},{key:"removeAt",value:function(e){this.records.splice(e,1);for(var t=e,n=this.size();t<n;t+=1)this.records[t].i-=1}},{key:"getValueForItemAtKeyId",value:function(e,t){return e[this._keysMap[t]]}},{key:"size",value:function(){return this.records.length}},{key:"_addString",value:function(e,t){if(x(e)&&!w(e)){var n={v:e,i:t,n:this.norm.get(e)};this.records.push(n)}}},{key:"_addObject",value:function(e,t){var n=this,r={i:t,$:{}};this.keys.forEach((function(t,i){var o=t.getFn?t.getFn(e):n.getFn(e,t.path);if(x(o))if(g(o)){for(var c=[],a=[{nestedArrIndex:-1,value:o}];a.length;){var s=a.pop(),u=s.nestedArrIndex,h=s.value;if(x(h))if(m(h)&&!w(h)){var l={v:h,i:u,n:n.norm.get(h)};c.push(l)}else g(h)&&h.forEach((function(e,t){a.push({nestedArrIndex:t,value:e})}))}r.$[i]=c}else if(m(o)&&!w(o)){var f={v:o,n:n.norm.get(o)};r.$[i]=f}})),this.records.push(r)}},{key:"toJSON",value:function(){return{keys:this.keys,records:this.records}}}]),e}();function P(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.getFn,i=void 0===r?$.getFn:r,o=n.fieldNormWeight,c=void 0===o?$.fieldNormWeight:o,a=new R({getFn:i,fieldNormWeight:c});return a.setKeys(e.map(A)),a.setSources(t),a.create(),a}function N(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.errors,r=void 0===n?0:n,i=t.currentLocation,o=void 0===i?0:i,c=t.expectedLocation,a=void 0===c?0:a,s=t.distance,u=void 0===s?$.distance:s,h=t.ignoreLocation,l=void 0===h?$.ignoreLocation:h,f=r/e.length;if(l)return f;var d=Math.abs(a-o);return u?f+d/u:d?1:f}var W=32;function T(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},i=r.location,o=void 0===i?$.location:i,c=r.distance,a=void 0===c?$.distance:c,s=r.threshold,u=void 0===s?$.threshold:s,h=r.findAllMatches,l=void 0===h?$.findAllMatches:h,f=r.minMatchCharLength,d=void 0===f?$.minMatchCharLength:f,v=r.includeMatches,g=void 0===v?$.includeMatches:v,y=r.ignoreLocation,p=void 0===y?$.ignoreLocation:y;if(t.length>W)throw new Error("Pattern length exceeds max of ".concat(W,"."));for(var m,k=t.length,M=e.length,b=Math.max(0,Math.min(o,M)),x=u,w=b,S=d>1||g,L=S?Array(M):[];(m=e.indexOf(t,w))>-1;){var _=N(t,{currentLocation:m,expectedLocation:b,distance:a,ignoreLocation:p});if(x=Math.min(_,x),w=m+k,S)for(var O=0;O<k;)L[m+O]=1,O+=1}w=-1;for(var j=[],A=1,I=k+M,C=1<<k-1,E=0;E<k;E+=1){for(var F=0,R=I;F<R;)N(t,{errors:E,currentLocation:b+R,expectedLocation:b,distance:a,ignoreLocation:p})<=x?F=R:I=R,R=Math.floor((I-F)/2+F);I=R;var P=Math.max(1,b-R+1),T=l?M:Math.min(b+R,M)+k,z=Array(T+2);z[T+1]=(1<<E)-1;for(var D=T;D>=P;D-=1){var K=D-1,q=n[e.charAt(K)];if(S&&(L[K]=+!!q),z[D]=(z[D+1]<<1|1)&q,E&&(z[D]|=(j[D+1]|j[D])<<1|1|j[D+1]),z[D]&C&&(A=N(t,{errors:E,currentLocation:K,expectedLocation:b,distance:a,ignoreLocation:p}))<=x){if(x=A,(w=K)<=b)break;P=Math.max(1,2*b-w)}}if(N(t,{errors:E+1,currentLocation:b,expectedLocation:b,distance:a,ignoreLocation:p})>x)break;j=z}var B={isMatch:w>=0,score:Math.max(.001,A)};if(S){var J=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:$.minMatchCharLength,n=[],r=-1,i=-1,o=0,c=e.length;o<c;o+=1){var a=e[o];a&&-1===r?r=o:a||-1===r||((i=o-1)-r+1>=t&&n.push([r,i]),r=-1)}return e[o-1]&&o-r>=t&&n.push([r,o-1]),n}(L,d);J.length?g&&(B.indices=J):B.isMatch=!1}return B}function z(e){for(var t={},n=0,r=e.length;n<r;n+=1){var i=e.charAt(n);t[i]=(t[i]||0)|1<<r-n-1}return t}var D=function(){function e(t){var n=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=i.location,c=void 0===o?$.location:o,a=i.threshold,s=void 0===a?$.threshold:a,u=i.distance,h=void 0===u?$.distance:u,l=i.includeMatches,f=void 0===l?$.includeMatches:l,d=i.findAllMatches,v=void 0===d?$.findAllMatches:d,g=i.minMatchCharLength,y=void 0===g?$.minMatchCharLength:g,p=i.isCaseSensitive,m=void 0===p?$.isCaseSensitive:p,k=i.ignoreLocation,M=void 0===k?$.ignoreLocation:k;if(r(this,e),this.options={location:c,threshold:s,distance:h,includeMatches:f,findAllMatches:v,minMatchCharLength:y,isCaseSensitive:m,ignoreLocation:M},this.pattern=m?t:t.toLowerCase(),this.chunks=[],this.pattern.length){var b=function(e,t){n.chunks.push({pattern:e,alphabet:z(e),startIndex:t})},x=this.pattern.length;if(x>W){for(var w=0,S=x%W,L=x-S;w<L;)b(this.pattern.substr(w,W),w),w+=W;if(S){var _=x-W;b(this.pattern.substr(_),_)}}else b(this.pattern,0)}}return o(e,[{key:"searchIn",value:function(e){var t=this.options,n=t.isCaseSensitive,r=t.includeMatches;if(n||(e=e.toLowerCase()),this.pattern===e){var i={isMatch:!0,score:0};return r&&(i.indices=[[0,e.length-1]]),i}var o=this.options,c=o.location,a=o.distance,s=o.threshold,u=o.findAllMatches,h=o.minMatchCharLength,l=o.ignoreLocation,d=[],v=0,g=!1;this.chunks.forEach((function(t){var n=t.pattern,i=t.alphabet,o=t.startIndex,y=T(e,n,i,{location:c+o,distance:a,threshold:s,findAllMatches:u,minMatchCharLength:h,includeMatches:r,ignoreLocation:l}),p=y.isMatch,m=y.score,k=y.indices;p&&(g=!0),v+=m,p&&k&&(d=[].concat(f(d),f(k)))}));var y={isMatch:g,score:g?v/this.chunks.length:1};return g&&r&&(y.indices=d),y}}]),e}(),K=function(){function e(t){r(this,e),this.pattern=t}return o(e,[{key:"search",value:function(){}}],[{key:"isMultiMatch",value:function(e){return q(e,this.multiRegex)}},{key:"isSingleMatch",value:function(e){return q(e,this.singleRegex)}}]),e}();function q(e,t){var n=e.match(t);return n?n[1]:null}var B=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){var t=e===this.pattern;return{isMatch:t,score:t?0:1,indices:[0,this.pattern.length-1]}}}],[{key:"type",get:function(){return"exact"}},{key:"multiRegex",get:function(){return/^="(.*)"$/}},{key:"singleRegex",get:function(){return/^=(.*)$/}}]),n}(K),J=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){var t=-1===e.indexOf(this.pattern);return{isMatch:t,score:t?0:1,indices:[0,e.length-1]}}}],[{key:"type",get:function(){return"inverse-exact"}},{key:"multiRegex",get:function(){return/^!"(.*)"$/}},{key:"singleRegex",get:function(){return/^!(.*)$/}}]),n}(K),U=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){var t=e.startsWith(this.pattern);return{isMatch:t,score:t?0:1,indices:[0,this.pattern.length-1]}}}],[{key:"type",get:function(){return"prefix-exact"}},{key:"multiRegex",get:function(){return/^\^"(.*)"$/}},{key:"singleRegex",get:function(){return/^\^(.*)$/}}]),n}(K),V=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){var t=!e.startsWith(this.pattern);return{isMatch:t,score:t?0:1,indices:[0,e.length-1]}}}],[{key:"type",get:function(){return"inverse-prefix-exact"}},{key:"multiRegex",get:function(){return/^!\^"(.*)"$/}},{key:"singleRegex",get:function(){return/^!\^(.*)$/}}]),n}(K),G=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){var t=e.endsWith(this.pattern);return{isMatch:t,score:t?0:1,indices:[e.length-this.pattern.length,e.length-1]}}}],[{key:"type",get:function(){return"suffix-exact"}},{key:"multiRegex",get:function(){return/^"(.*)"\$$/}},{key:"singleRegex",get:function(){return/^(.*)\$$/}}]),n}(K),H=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){var t=!e.endsWith(this.pattern);return{isMatch:t,score:t?0:1,indices:[0,e.length-1]}}}],[{key:"type",get:function(){return"inverse-suffix-exact"}},{key:"multiRegex",get:function(){return/^!"(.*)"\$$/}},{key:"singleRegex",get:function(){return/^!(.*)\$$/}}]),n}(K),Q=function(e){a(n,e);var t=l(n);function n(e){var i,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},c=o.location,a=void 0===c?$.location:c,s=o.threshold,u=void 0===s?$.threshold:s,h=o.distance,l=void 0===h?$.distance:h,f=o.includeMatches,d=void 0===f?$.includeMatches:f,v=o.findAllMatches,g=void 0===v?$.findAllMatches:v,y=o.minMatchCharLength,p=void 0===y?$.minMatchCharLength:y,m=o.isCaseSensitive,k=void 0===m?$.isCaseSensitive:m,M=o.ignoreLocation,b=void 0===M?$.ignoreLocation:M;return r(this,n),(i=t.call(this,e))._bitapSearch=new D(e,{location:a,threshold:u,distance:l,includeMatches:d,findAllMatches:g,minMatchCharLength:p,isCaseSensitive:k,ignoreLocation:b}),i}return o(n,[{key:"search",value:function(e){return this._bitapSearch.searchIn(e)}}],[{key:"type",get:function(){return"fuzzy"}},{key:"multiRegex",get:function(){return/^"(.*)"$/}},{key:"singleRegex",get:function(){return/^(.*)$/}}]),n}(K),X=function(e){a(n,e);var t=l(n);function n(e){return r(this,n),t.call(this,e)}return o(n,[{key:"search",value:function(e){for(var t,n=0,r=[],i=this.pattern.length;(t=e.indexOf(this.pattern,n))>-1;)n=t+i,r.push([t,n-1]);var o=!!r.length;return{isMatch:o,score:o?0:1,indices:r}}}],[{key:"type",get:function(){return"include"}},{key:"multiRegex",get:function(){return/^'"(.*)"$/}},{key:"singleRegex",get:function(){return/^'(.*)$/}}]),n}(K),Y=[B,X,U,V,H,G,J,Q],Z=Y.length,ee=/ +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/,te=new Set([Q.type,X.type]),ne=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=n.isCaseSensitive,o=void 0===i?$.isCaseSensitive:i,c=n.includeMatches,a=void 0===c?$.includeMatches:c,s=n.minMatchCharLength,u=void 0===s?$.minMatchCharLength:s,h=n.ignoreLocation,l=void 0===h?$.ignoreLocation:h,f=n.findAllMatches,d=void 0===f?$.findAllMatches:f,v=n.location,g=void 0===v?$.location:v,y=n.threshold,p=void 0===y?$.threshold:y,m=n.distance,k=void 0===m?$.distance:m;r(this,e),this.query=null,this.options={isCaseSensitive:o,includeMatches:a,minMatchCharLength:u,findAllMatches:d,ignoreLocation:l,location:g,threshold:p,distance:k},this.pattern=o?t:t.toLowerCase(),this.query=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return e.split("|").map((function(e){for(var n=e.trim().split(ee).filter((function(e){return e&&!!e.trim()})),r=[],i=0,o=n.length;i<o;i+=1){for(var c=n[i],a=!1,s=-1;!a&&++s<Z;){var u=Y[s],h=u.isMultiMatch(c);h&&(r.push(new u(h,t)),a=!0)}if(!a)for(s=-1;++s<Z;){var l=Y[s],f=l.isSingleMatch(c);if(f){r.push(new l(f,t));break}}}return r}))}(this.pattern,this.options)}return o(e,[{key:"searchIn",value:function(e){var t=this.query;if(!t)return{isMatch:!1,score:1};var n=this.options,r=n.includeMatches;e=n.isCaseSensitive?e:e.toLowerCase();for(var i=0,o=[],c=0,a=0,s=t.length;a<s;a+=1){var u=t[a];o.length=0,i=0;for(var h=0,l=u.length;h<l;h+=1){var d=u[h],v=d.search(e),g=v.isMatch,y=v.indices,p=v.score;if(!g){c=0,i=0,o.length=0;break}if(i+=1,c+=p,r){var m=d.constructor.type;te.has(m)?o=[].concat(f(o),f(y)):o.push(y)}}if(i){var k={isMatch:!0,score:c/i};return r&&(k.indices=o),k}}return{isMatch:!1,score:1}}}],[{key:"condition",value:function(e,t){return t.useExtendedSearch}}]),e}(),re=[];function ie(e,t){for(var n=0,r=re.length;n<r;n+=1){var i=re[n];if(i.condition(e,t))return new i(e,t)}return new D(e,t)}var oe="$and",ce="$or",ae="$path",se="$val",ue=function(e){return!(!e[oe]&&!e[ce])},he=function(e){return c({},oe,Object.keys(e).map((function(t){return c({},t,e[t])})))};function le(e,t){var n=(arguments.length>2&&void 0!==arguments[2]?arguments[2]:{}).auto,r=void 0===n||n;return ue(e)||(e=he(e)),function e(n){var i=Object.keys(n),o=function(e){return!!e[ae]}(n);if(!o&&i.length>1&&!ue(n))return e(he(n));if(function(e){return!g(e)&&b(e)&&!ue(e)}(n)){var c=o?n[ae]:i[0],a=o?n[se]:n[c];if(!m(a))throw new Error(function(e){return"Invalid value for key ".concat(e)}(c));var s={keyId:C(c),pattern:a};return r&&(s.searcher=ie(a,t)),s}var u={children:[],operator:i[0]};return i.forEach((function(t){var r=n[t];g(r)&&r.forEach((function(t){u.children.push(e(t))}))})),u}(e)}function fe(e,t){var n=e.matches;t.matches=[],x(n)&&n.forEach((function(e){if(x(e.indices)&&e.indices.length){var n={indices:e.indices,value:e.value};e.key&&(n.key=e.key.src),e.idx>-1&&(n.refIndex=e.idx),t.matches.push(n)}}))}function de(e,t){t.score=e.score}var ve=function(){function e(n){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=arguments.length>2?arguments[2]:void 0;r(this,e),this.options=t(t({},$),i),this.options.useExtendedSearch,this._keyStore=new j(this.options.keys),this.setCollection(n,o)}return o(e,[{key:"setCollection",value:function(e,t){if(this._docs=e,t&&!(t instanceof R))throw new Error("Incorrect 'index' type");this._myIndex=t||P(this.options.keys,this._docs,{getFn:this.options.getFn,fieldNormWeight:this.options.fieldNormWeight})}},{key:"add",value:function(e){x(e)&&(this._docs.push(e),this._myIndex.add(e))}},{key:"remove",value:function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){return!1},t=[],n=0,r=this._docs.length;n<r;n+=1){var i=this._docs[n];e(i,n)&&(this.removeAt(n),n-=1,r-=1,t.push(i))}return t}},{key:"removeAt",value:function(e){this._docs.splice(e,1),this._myIndex.removeAt(e)}},{key:"getIndex",value:function(){return this._myIndex}},{key:"search",value:function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).limit,n=void 0===t?-1:t,r=this.options,i=r.includeMatches,o=r.includeScore,c=r.shouldSort,a=r.sortFn,s=r.ignoreFieldNorm,u=m(e)?m(this._docs[0])?this._searchStringList(e):this._searchObjectList(e):this._searchLogical(e);return function(e,t){var n=t.ignoreFieldNorm,r=void 0===n?$.ignoreFieldNorm:n;e.forEach((function(e){var t=1;e.matches.forEach((function(e){var n=e.key,i=e.norm,o=e.score,c=n?n.weight:null;t*=Math.pow(0===o&&c?Number.EPSILON:o,(c||1)*(r?1:i))})),e.score=t}))}(u,{ignoreFieldNorm:s}),c&&u.sort(a),k(n)&&n>-1&&(u=u.slice(0,n)),function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.includeMatches,i=void 0===r?$.includeMatches:r,o=n.includeScore,c=void 0===o?$.includeScore:o,a=[];return i&&a.push(fe),c&&a.push(de),e.map((function(e){var n=e.idx,r={item:t[n],refIndex:n};return a.length&&a.forEach((function(t){t(e,r)})),r}))}(u,this._docs,{includeMatches:i,includeScore:o})}},{key:"_searchStringList",value:function(e){var t=ie(e,this.options),n=this._myIndex.records,r=[];return n.forEach((function(e){var n=e.v,i=e.i,o=e.n;if(x(n)){var c=t.searchIn(n),a=c.isMatch,s=c.score,u=c.indices;a&&r.push({item:n,idx:i,matches:[{score:s,value:n,norm:o,indices:u}]})}})),r}},{key:"_searchLogical",value:function(e){var t=this,n=le(e,this.options),r=function e(n,r,i){if(!n.children){var o=n.keyId,c=n.searcher,a=t._findMatches({key:t._keyStore.get(o),value:t._myIndex.getValueForItemAtKeyId(r,o),searcher:c});return a&&a.length?[{idx:i,item:r,matches:a}]:[]}for(var s=[],u=0,h=n.children.length;u<h;u+=1){var l=e(n.children[u],r,i);if(l.length)s.push.apply(s,f(l));else if(n.operator===oe)return[]}return s},i=this._myIndex.records,o={},c=[];return i.forEach((function(e){var t=e.$,i=e.i;if(x(t)){var a=r(n,t,i);a.length&&(o[i]||(o[i]={idx:i,item:t,matches:[]},c.push(o[i])),a.forEach((function(e){var t,n=e.matches;(t=o[i].matches).push.apply(t,f(n))})))}})),c}},{key:"_searchObjectList",value:function(e){var t=this,n=ie(e,this.options),r=this._myIndex,i=r.keys,o=r.records,c=[];return o.forEach((function(e){var r=e.$,o=e.i;if(x(r)){var a=[];i.forEach((function(e,i){a.push.apply(a,f(t._findMatches({key:e,value:r[i],searcher:n})))})),a.length&&c.push({idx:o,item:r,matches:a})}})),c}},{key:"_findMatches",value:function(e){var t=e.key,n=e.value,r=e.searcher;if(!x(n))return[];var i=[];if(g(n))n.forEach((function(e){var n=e.v,o=e.i,c=e.n;if(x(n)){var a=r.searchIn(n),s=a.isMatch,u=a.score,h=a.indices;s&&i.push({score:u,key:t,value:n,idx:o,norm:c,indices:h})}}));else{var o=n.v,c=n.n,a=r.searchIn(o),s=a.isMatch,u=a.score,h=a.indices;s&&i.push({score:u,key:t,value:o,norm:c,indices:h})}return i}}]),e}();ve.version="7.0.0",ve.createIndex=P,ve.parseIndex=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.getFn,r=void 0===n?$.getFn:r,i=t.fieldNormWeight,o=void 0===i?$.fieldNormWeight:o,c=e.keys,a=e.records,s=new R({getFn:r,fieldNormWeight:o});return s.setKeys(c),s.setIndexRecords(a),s},ve.config=$,function(){re.push.apply(re,arguments)}(ne);return ve})();

  // ─── CONFIG (injected by lineup.liquid) ───
  var CFG = window.__lineup || {};
  var PAGE = CFG.pageType || '';
  var FESTIVALS = CFG.festivals || [];
  var PRODUCT = CFG.product || null;
  var COLLECTION = CFG.collection || null;

  // ─── CONSTANTS ───
  var STORE_KEY = 'frw_lineups';
  // Default, festival-less save bucket. The heart saves here instantly — picking
  // a festival is an optional, secondary step (see quickSaveToFavorites).
  var FAVORITES_SLUG = '__favorites';
  var FAVORITES_NAME = 'Favorites';
  var HEART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>';
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var SEARCH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
  var SHARE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>';
  var CHEVRON_SVG = '<svg class="lu-day-group__chevron" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4,2 8,6 4,10"/></svg>';


  // ─── PICKER POSITIONING (flip-above + viewport clamp) ───
  // Defer to next animation frame so the just-appended popup has settled
  // dimensions. Without this, rect.width/height can be 0 on first call,
  // which causes the popup to land in unexpected positions (the bug Mike
  // saw with the picker "jumping around" after the split-button refactor).
  function positionPickerAnchored(el, anchorEl) {
    if (!anchorEl || !el) return;
    // Set a sane starting position so the popup doesn't flash at (0,0)
    // before rAF measures.
    el.style.visibility = 'hidden';
    el.style.top = '0';
    el.style.left = '0';
    requestAnimationFrame(function () {
      var anchor = anchorEl.getBoundingClientRect();
      var rect = el.getBoundingClientRect();
      // Defensive: anchor or popup not laid out → center on viewport
      if (rect.width <= 0 || rect.height <= 0 || (anchor.width === 0 && anchor.height === 0)) {
        el.style.top = Math.max(8, (window.innerHeight - rect.height) / 2) + 'px';
        el.style.left = Math.max(8, (window.innerWidth - rect.width) / 2) + 'px';
        el.style.visibility = '';
        return;
      }
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var margin = 8;
      // Vertical: prefer below; flip above only if it genuinely won't fit
      // and there's more room above.
      var spaceBelow = vh - anchor.bottom;
      var spaceAbove = anchor.top;
      var top;
      var fitsBelow = rect.height + margin <= spaceBelow;
      if (fitsBelow || spaceBelow >= spaceAbove) {
        top = anchor.bottom + margin;
      } else {
        top = anchor.top - rect.height - margin;
      }
      // Final clamp — never overflow viewport on either axis
      top = Math.max(margin, Math.min(top, vh - rect.height - margin));
      // Horizontal: align popup's right edge with anchor's right
      var desiredLeft = anchor.right - rect.width;
      var left = Math.max(margin, Math.min(desiredLeft, vw - rect.width - margin));
      el.style.top = top + 'px';
      el.style.left = left + 'px';
      el.style.visibility = '';
    });
  }

  // ─── BOTTOM SHEET ───
  // Hosts the save/day/remove pickers as a slide-up sheet from the bottom
  // edge of the viewport. Replaces the anchored popup pattern (which had
  // positioning bugs after the split-button refactor). One shared DOM
  // element reused across all picker calls.
  var $sheet = null, $sheetBackdrop = null, $sheetBody = null;
  function ensureSheet() {
    if ($sheet) return;
    $sheetBackdrop = el('div', 'lu-sheet-backdrop');
    $sheetBackdrop.addEventListener('click', closeSheet);
    document.body.appendChild($sheetBackdrop);

    $sheet = el('div', 'lu-sheet');
    $sheet.setAttribute('role', 'dialog');
    $sheet.setAttribute('aria-modal', 'true');

    var handle = el('div', 'lu-sheet__handle');
    $sheet.appendChild(handle);

    $sheetBody = el('div', 'lu-sheet__body');
    $sheet.appendChild($sheetBody);

    document.body.appendChild($sheet);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && $sheet && $sheet.classList.contains('open')) closeSheet();
    });
  }
  function openSheet(contentEl) {
    ensureSheet();
    $sheetBody.innerHTML = '';
    if (contentEl) $sheetBody.appendChild(contentEl);
    // Force layout so the slide-in transition runs from the start state.
    void $sheet.offsetWidth;
    $sheet.classList.add('open');
    $sheetBackdrop.classList.add('open');
    document.body.classList.add('lu-sheet-open');
  }
  function closeSheet() {
    if (!$sheet) return;
    $sheet.classList.remove('open');
    $sheetBackdrop.classList.remove('open');
    document.body.classList.remove('lu-sheet-open');
  }
  function isSheetOpen() {
    return !!($sheet && $sheet.classList.contains('open'));
  }

  // ─── STATE ───
  var state = loadState();
  var drawerOpen = false;
  var pickerOpen = false;
  var toastTimer = null;
  var _lastQuickSaved = null; // { product, btn } — most recent one-tap Favorites save (for the "Add to a festival" nudge)
  var _suggestCache = {};   // keyed by lineup ID → { products: [...], ts: Date.now() }
  var _suggestFetching = {}; // keyed by lineup ID → [callbacks]
  var _intelConfig = null;    // lineup-intel.json config, loaded once per session

  // ─── CACHED DOM REFS (set in buildDrawer) ───
  var $drawer = null;
  var $overlay = null;
  var $tabs = null;
  var $body = null;
  var $footer = null;

  // ─── BEACON (ESF analytics) ───
  var BEACON_URL = CFG.beaconUrl || null;
  var BEACON_KEY = CFG.beaconKey || '';
  var BEACON_BRAND = CFG.brandId || '';
  var beaconQueue = [];
  var beaconTimer = null;
  var beaconSessionId = (function () {
    try {
      var sid = sessionStorage.getItem('frw_lineup_sid');
      if (sid) return sid;
      sid = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem('frw_lineup_sid', sid);
      return sid;
    } catch (e) {
      return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }
  })();

  function beaconEnqueue(action, data) {
    if (!BEACON_URL) return;
    beaconQueue.push({ event: action, payload: data || {}, ts: Date.now() });
    if (beaconTimer) clearTimeout(beaconTimer);
    beaconTimer = setTimeout(beaconFlush, 5000);
  }

  function beaconFlush() {
    if (!BEACON_URL || beaconQueue.length === 0) return;
    var batch = beaconQueue.splice(0);
    var body = JSON.stringify({
      events: batch,
      sessionId: beaconSessionId,
      brandId: BEACON_BRAND,
    });
    try {
      fetch(BEACON_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Lineup-Key': BEACON_KEY },
        body: body,
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && BEACON_URL && beaconQueue.length > 0) {
      var body = JSON.stringify({
        events: beaconQueue.splice(0),
        sessionId: beaconSessionId,
        brandId: BEACON_BRAND,
      });
      try {
        navigator.sendBeacon(BEACON_URL + '?key=' + encodeURIComponent(BEACON_KEY), body);
      } catch (e) {}
    }
  });

  // ─── CDN EVENT INDEX (async enrichment) ───
  var CDN_URL = CFG.cdnIndexUrl || '';
  var cdnLoaded = false;

  // ─── FUSE.JS FUZZY SEARCH INDEX ───
  var fuseInstance = null;

  function rebuildFuseIndex() {
    fuseInstance = new Fuse(FESTIVALS, {
      keys: [
        { name: 'name', weight: 3 },
        { name: 'artists', weight: 2 },
        { name: 'venue', weight: 1.5 },
        { name: 'location', weight: 1 },
        { name: 'genres', weight: 1 },
        { name: 'slug', weight: 0.5 },
      ],
      threshold: 0.3,
      distance: 200,
      ignoreLocation: true,
      includeScore: true,
      minMatchCharLength: 1,
    });
  }

  function loadCdnEvents() {
    if (!CDN_URL) return;
    var cacheKey = 'frw_cdn_events';
    var cacheTTL = 3600000; // 1 hour
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && parsed.ts && Date.now() - parsed.ts < cacheTTL) {
          mergeCdnEvents(parsed.data);
          return;
        }
      }
    } catch (e) {}

    fetch(CDN_URL).then(function (r) { return r.json(); }).then(function (data) {
      // Unwrap tiers structure → flat array
      var events = [];
      if (data && data.tiers) {
        ['mega', 'regional', 'local'].forEach(function (t) {
          if (Array.isArray(data.tiers[t])) events = events.concat(data.tiers[t]);
        });
      } else if (Array.isArray(data)) {
        events = data;
      }
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ data: events, ts: Date.now() })); } catch (e) {}
      mergeCdnEvents(events);
    }).catch(function () {});
  }

  function cdnEntryToFestival(e) {
    var loc = e.city ? (e.city + ', ' + (e.state || '')) : '';
    return {
      name: e.name,
      slug: e.slug,
      start: e.date,
      end: e.end_date || e.date,
      location: loc,
      artists: e.artists || [],
      genres: e.genres || [],
      tier: e.tier || 'local',
      eventType: e.type || 'club_night',
      venue: e.venue || '',
      venueSlug: e.venue_slug || '',
      source: 'cdn',
      orderByQuick: e.order_by_quick || '',
      orderByPre: e.order_by_preorder || '',
      ticketUrl: e.ticket_url || null,
      spotifyUrl: e.spotify_playlist || null,
      guideUrl: e.guide_handle ? '/blogs/freedom-rave-wear-blog/' + e.guide_handle : null,
      collectionUrl: e.collection_handle ? '/collections/' + e.collection_handle : null,
    };
  }

  function mergeCdnEvents(index) {
    if (!Array.isArray(index)) return;
    var slugMap = {};
    FESTIVALS.forEach(function (f, i) { slugMap[f.slug] = i; });

    index.forEach(function (e) {
      var existing = slugMap[e.slug];
      if (typeof existing === 'number') {
        // Enrich hardcoded entry with CDN metadata
        var f = FESTIVALS[existing];
        if (!f.artists && e.artists) f.artists = e.artists;
        if (!f.genres && e.genres) f.genres = e.genres;
        if (!f.tier) f.tier = e.tier || 'local';
        if (!f.eventType) f.eventType = e.type || 'festival';
        if (!f.venue && e.venue) f.venue = e.venue;
      } else {
        // New event — append
        FESTIVALS.push(cdnEntryToFestival(e));
      }
    });

    cdnLoaded = true;
    rebuildFuseIndex();

    // Re-render picker if currently open (handles race condition)
    if (pickerOpen && pickerOverlayEl) {
      var listEl = pickerOverlayEl.querySelector('.lu-picker__list');
      var input = pickerOverlayEl.querySelector('.lu-picker__input');
      if (listEl) {
        var currentOnSelect = pickerOverlayEl._onSelect;
        renderFestivalList(listEl, input ? input.value.trim() : '', currentOnSelect);
      }
    }

    // Re-render lineup page if CDN loaded after initial render (picks up guide/spotify URLs)
    if (isLineupPage()) {
      renderPage();
    }
  }

  // ─── STATE MANAGEMENT ───
  function loadState() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && Array.isArray(parsed.lineups)) {
          // v1 → v2 migration: ensure all items have day field + skippedDays
          parsed.lineups.forEach(function (l) {
            l.items.forEach(function (i) {
              if (typeof i.day === 'undefined') i.day = 0;
            });
            if (!Array.isArray(l.skippedDays)) l.skippedDays = [];
          });
          return parsed;
        }
      }
    } catch (e) {}
    return { lineups: [], activeId: null };
  }

  function saveState() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
    // Re-render page if on lineup page (same-tab sync)
    if (isLineupPage()) renderPage();
  }

  function getActiveLineup() {
    if (!state.activeId && state.lineups.length) {
      state.activeId = state.lineups[0].id;
    }
    return state.lineups.find(function (l) { return l.id === state.activeId; }) || null;
  }

  function getAllItems() {
    var items = [];
    state.lineups.forEach(function (l) {
      l.items.forEach(function (i) { items.push(i); });
    });
    return items;
  }

  function isProductSaved(productId) {
    return getAllItems().some(function (i) { return String(i.productId) === String(productId); });
  }

  function getLineupsForProduct(productId) {
    return state.lineups.filter(function (l) {
      return l.items.some(function (i) { return String(i.productId) === String(productId); });
    });
  }

  function getItemInLineup(lineupId, productId) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup) return null;
    return lineup.items.find(function (i) { return String(i.productId) === String(productId); }) || null;
  }

  // ─── LINEUP CRUD ───
  function createLineup(festival) {
    var id = festival.slug + '-' + Date.now().toString(36);
    var lineup = {
      id: id,
      festival: {
        slug: festival.slug,
        name: festival.name,
        start: festival.start,
        end: festival.end,
        location: festival.location || '',
        source: festival.source || 'master',
        guideUrl: festival.guideUrl || null,
        collectionUrl: festival.collectionUrl || null,
        spotifyUrl: festival.spotifyUrl || null,
        ticketUrl: festival.ticketUrl || null,
        orderByQuick: festival.orderByQuick || '',
        orderByPre: festival.orderByPre || '',
        artists: festival.artists || [],
        genres: festival.genres || [],
        tier: festival.tier || '',
        eventType: festival.eventType || '',
        venue: festival.venue || '',
      },
      items: [],
      skippedDays: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    state.lineups.push(lineup);
    state.activeId = id;
    saveState();
    trackEvent('lineup_created', { festival: festival.slug, source: festival.source || 'master' });
    return lineup;
  }

  // ─── FAVORITES (default save bucket — no festival required) ───
  function isFavoritesLineup(lineup) {
    return !!(lineup && lineup.festival && lineup.festival.slug === FAVORITES_SLUG);
  }

  function getFavoritesLineup() {
    return state.lineups.find(isFavoritesLineup) || null;
  }

  function getOrCreateFavorites() {
    var fav = getFavoritesLineup();
    if (fav) return fav;
    fav = {
      id: FAVORITES_SLUG,
      festival: {
        slug: FAVORITES_SLUG,
        name: FAVORITES_NAME,
        start: '',
        end: '',
        location: '',
        source: 'default',
        guideUrl: null,
        collectionUrl: null,
        spotifyUrl: null,
        ticketUrl: null,
        orderByQuick: '',
        orderByPre: '',
        artists: [],
        genres: [],
        tier: '',
        eventType: 'favorites',
        venue: '',
      },
      items: [],
      skippedDays: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    // Keep Favorites first so it's the default-active tab in the drawer.
    state.lineups.unshift(fav);
    state.activeId = fav.id;
    saveState();
    trackEvent('favorites_created', {});
    return fav;
  }

  // One-tap save: drop the product straight into Favorites, no festival gate.
  // Returns true if newly added. Festival assignment is offered as a soft,
  // optional nudge in the toast (data-action="add-festival").
  function quickSaveToFavorites(product, btn) {
    var fav = getOrCreateFavorites();
    var added = addItem(fav.id, product, 0);
    if (added) {
      _lastQuickSaved = { product: product, btn: btn || null };
      if (btn) { btn.classList.add('lu-save--active'); bounceBtn(btn); }
      trackEvent('favorite_added', { product_id: product.id, price: product.price });
      showToast(
        'Saved to <span class="lu-accent">' + FAVORITES_NAME + '</span> ' +
        '<span class="lu-toast-link" data-action="open-drawer">View</span>' +
        '<span class="lu-toast-sep">·</span>' +
        '<span class="lu-toast-link" data-action="add-festival">Add to a festival</span>',
        4000, btn
      );
      updateAllSaveButtons();
    }
    return added;
  }

  function deleteLineup(lineupId) {
    state.lineups = state.lineups.filter(function (l) { return l.id !== lineupId; });
    if (state.activeId === lineupId) {
      state.activeId = state.lineups.length ? state.lineups[0].id : null;
    }
    saveState();
    trackEvent('lineup_deleted', { lineup_id: lineupId });
  }

  function addItem(lineupId, product, day) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup) return false;

    var exists = lineup.items.some(function (i) { return String(i.productId) === String(product.id); });
    if (exists) return false;

    var pfSize = getPerfectFitSize();

    lineup.items.push({
      productId: String(product.id),
      handle: product.handle || '',
      title: product.title || '',
      price: product.price || 0,
      image: product.image || '',
      url: product.url || '',
      size: pfSize || '',
      addedAt: new Date().toISOString(),
      day: typeof day === 'number' ? day : 0,
    });
    lineup.updatedAt = new Date().toISOString();
    saveState();
    trackEvent('lineup_item_added', {
      lineup_id: lineupId,
      festival: lineup.festival.slug,
      product_id: product.id,
      price: product.price,
      day: typeof day === 'number' ? day : 0,
    });
    return true;
  }

  function removeItem(lineupId, productId) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup) return;
    lineup.items = lineup.items.filter(function (i) { return String(i.productId) !== String(productId); });
    lineup.updatedAt = new Date().toISOString();
    saveState();
    trackEvent('lineup_item_removed', { lineup_id: lineupId, product_id: productId });
  }

  function moveItem(lineupId, productId, toDay) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup) return;
    var item = lineup.items.find(function (i) { return String(i.productId) === String(productId); });
    if (!item) return;
    item.day = toDay;
    lineup.updatedAt = new Date().toISOString();
    saveState();
    trackEvent('lineup_item_moved', { lineup_id: lineupId, product_id: productId, to_day: toDay });
  }

  // ─── DAY SKIP ───
  function isDaySkipped(lineup, dayNum) {
    return Array.isArray(lineup.skippedDays) && lineup.skippedDays.indexOf(dayNum) !== -1;
  }

  function skipDay(lineupId, dayNum) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup) return;
    if (!Array.isArray(lineup.skippedDays)) lineup.skippedDays = [];
    if (lineup.skippedDays.indexOf(dayNum) === -1) {
      lineup.skippedDays.push(dayNum);
      lineup.updatedAt = new Date().toISOString();
      saveState();
      trackEvent('lineup_day_skipped', { lineup_id: lineupId, day: dayNum });
    }
  }

  function restoreDay(lineupId, dayNum) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup || !Array.isArray(lineup.skippedDays)) return;
    var idx = lineup.skippedDays.indexOf(dayNum);
    if (idx !== -1) {
      lineup.skippedDays.splice(idx, 1);
      lineup.updatedAt = new Date().toISOString();
      saveState();
      trackEvent('lineup_day_restored', { lineup_id: lineupId, day: dayNum });
    }
  }

  // ─── INTEGRATIONS ───
  function getPerfectFitSize() {
    // Quick pick (from Find Your Fit) overrides quiz profile
    try {
      var qs = JSON.parse(localStorage.getItem('frw_quick_size') || 'null');
      if (qs && qs.size && Date.now() - (qs.ts || 0) < 90 * 86400000) return qs.size;
    } catch (e) {}
    try {
      var pf = JSON.parse(localStorage.getItem('frw_perfect_fit') || 'null');
      if (pf && pf.v) return pf.v;
    } catch (e) {}
    return null;
  }

  function getShoppingMode() {
    try {
      return JSON.parse(localStorage.getItem('frw_shopping_mode') || 'null');
    } catch (e) {}
    return null;
  }

  function getBudgetMode() {
    try {
      return JSON.parse(localStorage.getItem('frw_budget_mode') || 'null');
    } catch (e) {}
    return null;
  }

  // ─── ANALYTICS ───
  function trackEvent(action, data) {
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: 'frw:' + action }, data || {}));
    }
    beaconEnqueue(action, data);
  }

  // ─── HELPERS ───
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function daysUntil(dateStr) {
    if (!dateStr) return null;
    var diff = Math.ceil((new Date(dateStr + 'T00:00:00') - new Date()) / 86400000);
    return diff > 0 ? diff : null;
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function getFestivalDays(lineup) {
    if (!lineup || !lineup.festival) return 1;
    // Favorites (and any dateless bucket) is single-day — never show a day picker.
    if (!lineup.festival.start || !lineup.festival.end) return 1;
    var s = new Date(lineup.festival.start + 'T00:00:00');
    var e = new Date(lineup.festival.end + 'T00:00:00');
    return Math.max(1, Math.ceil((e - s) / 86400000) + 1);
  }

  function getDayLabel(lineup, dayNum) {
    if (!lineup || !lineup.festival || dayNum < 1) return 'Unassigned';
    var s = new Date(lineup.festival.start + 'T00:00:00');
    var d = new Date(s);
    d.setDate(d.getDate() + dayNum - 1);
    var dayName = d.toLocaleDateString('en-US', { weekday: 'short' });
    var dateStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    return 'Day ' + dayNum + ' \u2014 ' + dayName + ' ' + dateStr;
  }

  // ─── FLY-TO-NAV ANIMATION ───
  function flyToNav(sourceEl) {
    var nav = document.getElementById('lu-nav-btn');
    if (!nav || !sourceEl) return;

    // Reduced motion check
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pulseNav();
      return;
    }

    var srcRect = sourceEl.getBoundingClientRect();
    var navRect = nav.getBoundingClientRect();

    var startX = srcRect.left + srcRect.width / 2;
    var startY = srcRect.top + srcRect.height / 2;
    var endX = navRect.left + navRect.width / 2;
    var endY = navRect.top + navRect.height / 2;

    var fly = el('div', 'lu-fly', HEART_SVG);
    fly.style.setProperty('--lu-fly-start-x', startX + 'px');
    fly.style.setProperty('--lu-fly-start-y', startY + 'px');
    fly.style.setProperty('--lu-fly-travel-x', (endX - startX) + 'px');
    fly.style.setProperty('--lu-fly-travel-y', (endY - startY) + 'px');

    document.body.appendChild(fly);

    // Wait for animations to finish, then remove + pulse nav
    if (fly.getAnimations) {
      Promise.allSettled(fly.getAnimations().map(function (a) { return a.finished; })).then(function () {
        fly.remove();
        pulseNav();
      });
    } else {
      // Fallback for browsers without getAnimations
      setTimeout(function () {
        fly.remove();
        pulseNav();
      }, 650);
    }
  }

  function pulseNav() {
    var nav = document.getElementById('lu-nav-btn');
    if (!nav) return;
    nav.classList.remove('lu-nav-icon--pulse');
    void nav.offsetWidth;
    nav.classList.add('lu-nav-icon--pulse');
    setTimeout(function () { nav.classList.remove('lu-nav-icon--pulse'); }, 400);
  }

  // ─── TOAST ───
  var toastEl = null;
  function showToast(html, duration, anchorEl) {
    if (!toastEl) {
      toastEl = el('div', 'lu-toast');
      document.body.appendChild(toastEl);
    }
    clearTimeout(toastTimer);
    toastEl.innerHTML = html;
    toastEl.classList.remove('visible');

    // Always render at bottom-center via base CSS. Anchored mode was buggy:
    // the toast is ~95vw wide on mobile, and a transform: translateX(-50%)
    // on the anchor's center X pushed it off-screen for any non-centered
    // button. anchorEl is kept in the signature for callers but ignored.
    toastEl.classList.remove('lu-toast--anchored');
    toastEl.style.top = '';
    toastEl.style.left = '';

    void toastEl.offsetWidth;
    toastEl.classList.add('visible');

    var link = toastEl.querySelector('[data-action="open-drawer"]');
    if (link) {
      link.addEventListener('click', function () {
        clearTimeout(toastTimer);
        toastEl.classList.remove('visible');
        openDrawer();
      });
    }

    // Soft, optional festival upsell after a one-tap Favorites save.
    var festLink = toastEl.querySelector('[data-action="add-festival"]');
    if (festLink) {
      festLink.addEventListener('click', function () {
        clearTimeout(toastTimer);
        toastEl.classList.remove('visible');
        if (_lastQuickSaved && _lastQuickSaved.product) {
          // Opens the festival search picker and also adds the item to the chosen festival.
          saveToLineup(_lastQuickSaved.product, _lastQuickSaved.btn);
        } else {
          openPicker(function () { updateNavCount(); });
        }
      });
    }

    toastTimer = setTimeout(function () {
      toastEl.classList.remove('visible');
    }, duration || 3000);
  }

  // ─── SAVE BUTTONS ON PRODUCT CARDS ───
  function injectCardButtons() {
    // Target all product card types: collection grid cards, resource cards (homepage/search/recs)
    var cards = document.querySelectorAll(
      'product-card[data-product-id], product-card-link[data-product-id], .resource-card[data-resource-type="product"]'
    );
    cards.forEach(function (card) {
      // Extract product ID — from data attribute or from link href
      var productId = card.getAttribute('data-product-id');
      if (!productId) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          var href = link.getAttribute('href');
          var handle = href.split('/products/')[1];
          if (handle) productId = handle.split('?')[0].split('#')[0];
        }
      }
      if (!productId) return;

      // Hydrate existing placeholder or create new button
      var btn = card.querySelector('.lu-save');
      if (!btn) {
        btn = el('button', 'lu-save', HEART_SVG);
        btn.setAttribute('aria-label', 'Save to favorites');
        btn.setAttribute('type', 'button');
        var imgWrap = card.querySelector('.product-card__link, .resource-card__media') || card;
        if (!imgWrap.style.position) imgWrap.style.position = 'relative';
        imgWrap.appendChild(btn);
      }

      if (btn.dataset.luHydrated) return;
      btn.dataset.luHydrated = '1';

      if (isProductSaved(productId)) {
        btn.classList.add('lu-save--active');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleCardSave(card, btn, productId);
      });
    });
  }

  function handleCardSave(card, btn, productId) {
    var isSaved = isProductSaved(productId);

    // If the sheet is already open, close it (toggle behavior)
    if (isSheetOpen()) { closeSheet(); return; }

    // Build product object from card DOM (needed for both save and switch)
    var link = card.querySelector('a[href]');
    var titleEl = card.querySelector('.product-card__title, .card__heading, .resource-card__title') || {};
    var img = card.querySelector('img');
    var product = {
      id: productId,
      handle: link ? link.getAttribute('href').split('/').pop().split('?')[0] : '',
      title: (titleEl.textContent || '').trim(),
      price: parseInt(card.getAttribute('data-price')) || 0,
      image: img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '',
      url: link ? link.getAttribute('href') : '',
    };

    if (isSaved) {
      var savedIn = getLineupsForProduct(productId);
      if (savedIn.length > 1) {
        // Multi-festival: show remove picker with confirmation
        showRemovePicker(productId, savedIn, btn, product);
      } else if (savedIn.length === 1) {
        // Single festival: confirm before removing, with switch option
        var item = getItemInLineup(savedIn[0].id, productId);
        var dayNum = item ? item.day : 0;
        showRemoveConfirm(savedIn[0].festival.name, dayNum, btn, function () {
          removeItem(savedIn[0].id, productId);
          btn.classList.remove('lu-save--active');
          showToast('Removed from <span class="lu-accent">' + savedIn[0].festival.name + '</span>', 2000, btn);
          updateAllSaveButtons();
        }, function () {
          // Switch: remove from current, then open festival picker to reassign
          removeItem(savedIn[0].id, productId);
          saveToLineup(product, btn);
        });
      }
      return;
    }

    // One tap = saved to Favorites. Festival assignment is an optional toast nudge.
    quickSaveToFavorites(product, btn);
  }

  function saveToLineup(product, btn) {
    // Always show festival search picker first, then day picker
    openPicker(function (lineup) {
      var numDays = getFestivalDays(lineup);
      if (numDays > 1) {
        showDayPicker(lineup, product, function (day) {
          var added = addItem(lineup.id, product, day);
          if (added) {
            btn.classList.add('lu-save--active');
            bounceBtn(btn);
            showToast('Saved to <span class="lu-accent">' + lineup.festival.name + '</span> — ' + (day > 0 ? 'Day ' + day : 'Unassigned') + ' <span class="lu-toast-link" data-action="open-drawer">View</span>', 3000, btn);
            updateAllSaveButtons();
          }
        }, btn);
      } else {
        var added = addItem(lineup.id, product, 0);
        if (added) {
          btn.classList.add('lu-save--active');
          bounceBtn(btn);
          showToast('Saved to <span class="lu-accent">' + lineup.festival.name + '</span> outfit lineup <span class="lu-toast-link" data-action="open-drawer">View</span>', 3000, btn);
          updateAllSaveButtons();
        }
      }
    });
  }

  function showQuickPicker(product, btn) {
    var picker = el('div', 'lu-quick-picker');
    var header = el('div', 'lu-quick-picker__header', '<span>Save to...</span>');
    picker.appendChild(header);

    state.lineups.forEach(function (lineup) {
      var alreadySaved = lineup.items.some(function (i) { return String(i.productId) === String(product.id); });
      var row = el('div', 'lu-quick-picker__row-wrap');
      var rowBtn = el('button', 'lu-quick-picker__row' + (alreadySaved ? ' lu-quick-picker__row--saved' : ''));
      rowBtn.textContent = lineup.festival.name + (alreadySaved ? ' \u2713' : '');
      rowBtn.setAttribute('type', 'button');
      if (alreadySaved) {
        rowBtn.addEventListener('click', function () {
          removeItem(lineup.id, product.id);
          rowBtn.classList.remove('lu-quick-picker__row--saved');
          rowBtn.textContent = lineup.festival.name;
          showToast('Removed from <span class="lu-accent">' + lineup.festival.name + '</span>', 2000, btn);
          updateAllSaveButtons();
        });
      } else {
        rowBtn.addEventListener('click', function () {
          var numDays = getFestivalDays(lineup);
          if (numDays > 1) {
            showDayPicker(lineup, product, function (day) {
              addItem(lineup.id, product, day);
              btn.classList.add('lu-save--active');
              bounceBtn(btn);
              showToast('Saved to <span class="lu-accent">' + lineup.festival.name + '</span> — ' + (day > 0 ? 'Day ' + day : 'Unassigned') + ' <span class="lu-toast-link" data-action="open-drawer">View</span>', 3000, btn);
              updateAllSaveButtons();
            }, btn);
          } else {
            addItem(lineup.id, product, 0);
            btn.classList.add('lu-save--active');
            bounceBtn(btn);
            showToast('Saved to <span class="lu-accent">' + lineup.festival.name + '</span> <span class="lu-toast-link" data-action="open-drawer">View</span>', 3000, btn);
            closeSheet();
            updateAllSaveButtons();
          }
        });
      }
      row.appendChild(rowBtn);

      var removeBtn = el('button', 'lu-quick-picker__remove', '\u00D7');
      removeBtn.setAttribute('type', 'button');
      removeBtn.setAttribute('aria-label', 'Remove ' + lineup.festival.name + ' outfit lineup');
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        deleteLineup(lineup.id);
        row.remove();
        showToast('Removed <span class="lu-accent">' + lineup.festival.name + '</span> outfit lineup', 2000, btn);
        updateAllSaveButtons();
        if (state.lineups.length === 0) closeSheet();
      });
      row.appendChild(removeBtn);

      picker.appendChild(row);
    });

    var addBtn = el('button', 'lu-quick-picker__row lu-quick-picker__row--add', '+ Festival');
    addBtn.setAttribute('type', 'button');
    addBtn.addEventListener('click', function () {
      closeSheet();
      openPicker(function (newLineup) {
        showQuickPicker(product, btn);
      });
    });
    picker.appendChild(addBtn);

    openSheet(picker);
  }

  // ─── REMOVE PICKER (multi-festival unsave) ───
  function showRemovePicker(productId, lineups, anchorBtn, product) {
    var picker = el('div', 'lu-quick-picker');
    var header = el('div', 'lu-quick-picker__header', '<span>Remove from\u2026</span>');
    picker.appendChild(header);

    lineups.forEach(function (lineup) {
      var item = getItemInLineup(lineup.id, productId);
      var dayNum = item ? item.day : 0;
      var row = el('button', 'lu-quick-picker__row');
      row.textContent = lineup.festival.name + (dayNum > 0 ? ' (Day ' + dayNum + ')' : '');
      row.setAttribute('type', 'button');
      row.addEventListener('click', function () {
        var switchCb = product ? function () {
          removeItem(lineup.id, productId);
          saveToLineup(product, anchorBtn);
        } : null;
        showRemoveConfirm(lineup.festival.name, dayNum, anchorBtn, function () {
          removeItem(lineup.id, productId);
          showToast('Removed from <span class="lu-accent">' + lineup.festival.name + '</span>', 2000, anchorBtn);
          updateAllSaveButtons();
          var remaining = getLineupsForProduct(productId);
          if (remaining.length > 0) {
            showRemovePicker(productId, remaining, anchorBtn, product);
          } else {
            closeSheet();
          }
        }, switchCb);
      });
      picker.appendChild(row);
    });

    var removeAllBtn = el('button', 'lu-quick-picker__row lu-quick-picker__row--danger', 'Remove from all');
    removeAllBtn.setAttribute('type', 'button');
    removeAllBtn.addEventListener('click', function () {
      showRemoveAllConfirm(lineups.length, anchorBtn, function () {
        lineups.forEach(function (l) { removeItem(l.id, productId); });
        showToast('Removed from all outfit lineups', 2000, anchorBtn);
        updateAllSaveButtons();
        closeSheet();
      });
    });
    picker.appendChild(removeAllBtn);

    openSheet(picker);
  }

  // ─── REMOVE CONFIRMATION ───
  function showRemoveConfirm(festivalName, dayNum, anchorBtn, onConfirm, onSwitch) {
    var popup = el('div', 'lu-remove-confirm lu-quick-picker');
    var header = el('div', 'lu-quick-picker__header', '<span>Remove from ' + festivalName + '?</span>');
    popup.appendChild(header);

    var msg = el('div', 'lu-confirm__message');
    if (dayNum === -1) {
      msg.textContent = 'This lineup has saved outfits that will be lost. Remove it?';
    } else if (dayNum > 0) {
      msg.textContent = 'This piece is assigned to Day ' + dayNum + ' \u2014 it will be unassigned from your outfit lineup.';
    } else {
      msg.textContent = 'This piece will be removed from your outfit lineup.';
    }
    popup.appendChild(msg);

    var actions = el('div', 'lu-confirm__actions');

    var removeBtn = el('button', 'lu-confirm__btn lu-confirm__btn--remove', 'Remove');
    removeBtn.setAttribute('type', 'button');
    removeBtn.addEventListener('click', function () {
      closeSheet();
      onConfirm();
    });
    actions.appendChild(removeBtn);

    if (onSwitch) {
      var switchBtn = el('button', 'lu-confirm__btn lu-confirm__btn--switch', 'Switch');
      switchBtn.setAttribute('type', 'button');
      switchBtn.addEventListener('click', function () {
        closeSheet();
        onSwitch();
      });
      actions.appendChild(switchBtn);
    }

    var keepBtn = el('button', 'lu-confirm__btn lu-confirm__btn--keep', 'Keep');
    keepBtn.setAttribute('type', 'button');
    keepBtn.addEventListener('click', closeSheet);
    actions.appendChild(keepBtn);

    popup.appendChild(actions);

    openSheet(popup);
  }

  function showRemoveAllConfirm(count, anchorBtn, onConfirm) {
    var popup = el('div', 'lu-remove-confirm lu-quick-picker');
    var header = el('div', 'lu-quick-picker__header', '<span>Remove from all?</span>');
    popup.appendChild(header);

    var msg = el('div', 'lu-confirm__message');
    msg.textContent = 'This piece is in ' + count + ' lineup' + (count > 1 ? 's' : '') + '. Remove from all?';
    popup.appendChild(msg);

    var actions = el('div', 'lu-confirm__actions');

    var removeBtn = el('button', 'lu-confirm__btn lu-confirm__btn--remove', 'Remove All');
    removeBtn.setAttribute('type', 'button');
    removeBtn.addEventListener('click', function () {
      closeSheet();
      onConfirm();
    });

    var keepBtn = el('button', 'lu-confirm__btn lu-confirm__btn--keep', 'Keep');
    keepBtn.setAttribute('type', 'button');
    keepBtn.addEventListener('click', closeSheet);

    actions.appendChild(removeBtn);
    actions.appendChild(keepBtn);
    popup.appendChild(actions);

    openSheet(popup);
  }

  // ─── DAY PICKER ───
  function showDayPicker(lineup, product, callback, anchorBtn) {
    var numDays = getFestivalDays(lineup);
    var popup = el('div', 'lu-day-picker-popup lu-quick-picker');
    var header = el('div', 'lu-quick-picker__header', '<span>Which day?</span>');
    popup.appendChild(header);

    var chips = el('div', 'lu-day-chips');

    for (var d = 1; d <= numDays; d++) {
      (function (dayNum) {
        if (isDaySkipped(lineup, dayNum)) return;
        var chip = el('button', 'lu-day-chips__chip');
        chip.textContent = getDayLabel(lineup, dayNum);
        chip.setAttribute('type', 'button');
        chip.addEventListener('click', function () {
          closeSheet();
          callback(dayNum);
        });
        chips.appendChild(chip);
      })(d);
    }

    // "No day" option
    var noDay = el('button', 'lu-day-chips__chip');
    noDay.textContent = 'Just packing';
    noDay.setAttribute('type', 'button');
    noDay.addEventListener('click', function () {
      closeSheet();
      callback(0);
    });
    chips.appendChild(noDay);

    popup.appendChild(chips);

    // "+ Another festival" option
    var addFestBtn = el('button', 'lu-quick-picker__row lu-quick-picker__row--add', '+ Another festival');
    addFestBtn.setAttribute('type', 'button');
    addFestBtn.addEventListener('click', function () {
      closeSheet();
      openPicker(function (newLineup) {
        var newDays = getFestivalDays(newLineup);
        if (newDays > 1 && newDays <= 5) {
          showDayPicker(newLineup, product, function (day) {
            addItem(newLineup.id, product, day);
            if (anchorBtn) {
              anchorBtn.classList.add('lu-save--active');
              bounceBtn(anchorBtn);
            }
            showToast('Saved to <span class="lu-accent">' + newLineup.festival.name + '</span> — ' + (day > 0 ? 'Day ' + day : 'Unassigned') + ' <span class="lu-toast-link" data-action="open-drawer">View</span>', 3000, anchorBtn);
            updateAllSaveButtons();
          }, anchorBtn);
        } else {
          addItem(newLineup.id, product, 0);
          showToast('Saved to <span class="lu-accent">' + newLineup.festival.name + '</span> <span class="lu-toast-link" data-action="open-drawer">View</span>', 3000, anchorBtn);
          updateAllSaveButtons();
        }
      });
    });
    popup.appendChild(addFestBtn);

    openSheet(popup);
  }

  function bounceBtn(btn) {
    btn.classList.remove('lu-save--bounce');
    void btn.offsetWidth;
    btn.classList.add('lu-save--bounce');
    flyToNav(btn);
  }

  function updateAllSaveButtons() {
    document.querySelectorAll('.lu-save').forEach(function (btn) {
      var card = btn.closest('product-card[data-product-id]');
      if (!card) return;
      var pid = card.getAttribute('data-product-id');
      btn.classList.toggle('lu-save--active', isProductSaved(pid));
    });
    // Re-render the entire PDP bar so pills + button state stay in sync
    var pdpBar = document.querySelector('.lu-pdp-bar');
    if (pdpBar && PRODUCT) {
      pdpBar.remove();
      injectPDPSave();
    }
    updateNavCount();
  }

  // ─── PDP SAVE BAR ───
  function injectPDPSave() {
    if (!PRODUCT) return;
    var formButtons = document.querySelector('.product-form-buttons');
    if (!formButtons) return;

    var bar = document.getElementById('lu-pdp-placeholder');
    if (!bar) {
      if (document.querySelector('.lu-pdp-bar')) return;
      bar = el('div', 'lu-pdp-bar');
      formButtons.parentNode.insertBefore(bar, formButtons.nextSibling);
    }
    if (bar.dataset.luHydrated) return;
    bar.dataset.luHydrated = '1';
    var saved = isProductSaved(PRODUCT.id);

    // Hydrate existing placeholder button or create new one
    var saveBtn = bar.querySelector('.lu-pdp-save');
    if (saveBtn) {
      saveBtn.innerHTML = HEART_SVG + '<span>' + (saved ? 'Saved \u2713' : 'Save') + '</span>';
      if (saved) saveBtn.classList.add('lu-pdp-save--active');
    } else {
      saveBtn = el('button', 'lu-pdp-save' + (saved ? ' lu-pdp-save--active' : ''),
        HEART_SVG + '<span>' + (saved ? 'Saved \u2713' : 'Save') + '</span>'
      );
      saveBtn.setAttribute('type', 'button');
      bar.appendChild(saveBtn);
    }

    saveBtn.addEventListener('click', function () {
      // If the sheet is already open, close it (toggle behavior)
      if (isSheetOpen()) { closeSheet(); return; }

      if (isProductSaved(PRODUCT.id)) {
        // Already saved — confirm removal (toggle off) with switch option
        var savedIn = getLineupsForProduct(PRODUCT.id);
        if (savedIn.length > 1) {
          showRemovePicker(PRODUCT.id, savedIn, saveBtn, PRODUCT);
        } else if (savedIn.length === 1) {
          var item = getItemInLineup(savedIn[0].id, PRODUCT.id);
          var dayNum = item ? item.day : 0;
          showRemoveConfirm(savedIn[0].festival.name, dayNum, saveBtn, function () {
            removeItem(savedIn[0].id, PRODUCT.id);
            saveBtn.classList.remove('lu-pdp-save--active');
            saveBtn.querySelector('span:last-child').textContent = 'Save';
            showToast('Removed from <span class="lu-accent">' + savedIn[0].festival.name + '</span>', 2000, saveBtn);
            updateAllSaveButtons();
          }, function () {
            // Switch: remove from current, open picker to reassign
            removeItem(savedIn[0].id, PRODUCT.id);
            saveToLineup(PRODUCT, saveBtn);
            saveBtn.querySelector('span:last-child').textContent = 'Saved ✓';
          });
        }
      } else {
        // One tap = saved. No festival gate; festival is an optional nudge in the toast.
        var didSave = quickSaveToFavorites(PRODUCT, saveBtn);
        if (didSave) saveBtn.querySelector('span:last-child').textContent = 'Saved ✓';
      }
    });

    var lineups = getLineupsForProduct(PRODUCT.id);
    if (lineups.length > 0) {
      var pills = el('div', 'lu-fest-pills open');
      lineups.forEach(function (l) {
        var pill = el('span', 'lu-fest-pill lu-fest-pill--active', l.festival.name);
        pills.appendChild(pill);
      });
      bar.appendChild(pills);
    }

  }

  // ─── NAV ICON ───
  function injectNavIcon() {
    var nav = document.getElementById('lu-nav-btn');
    if (!nav) return;

    nav.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Close any open theme dialogs (cart, account) to prevent double slideout
      document.querySelectorAll('dialog[open]').forEach(function (d) {
        try { d.close(); } catch (ex) {}
      });
      // Always open the drawer — its empty state guides first-time savers
      // (no more forced festival picker just to view saves).
      openDrawer();
    });

    updateNavCount();
  }

  function updateNavCount() {
    var countEl = document.querySelector('.lu-nav-icon__count');
    if (countEl) {
      var total = getAllItems().length;
      countEl.textContent = total || '';
      countEl.style.display = total > 0 ? 'flex' : 'none';
    }
  }

  // ─── DRAWER ───
  function buildDrawer() {
    if ($drawer) return;

    $overlay = el('div', 'lu-drawer-overlay');
    $overlay.addEventListener('click', function (e) {
      e.stopPropagation();
      closeDrawer();
    });

    $drawer = el('div', 'lu-drawer');
    $drawer.innerHTML = '<div class="lu-drawer__header">' +
      '<span class="lu-drawer__title">Saved Items</span>' +
      '<a class="lu-drawer__page-link" href="/pages/lineup">View All</a>' +
      '<button class="lu-drawer__close" type="button">' + CLOSE_SVG + '</button>' +
      '</div>' +
      '<div class="lu-drawer__tabs-wrap"><div class="lu-drawer__tabs"></div></div>' +
      '<div class="lu-drawer__body"></div>' +
      '<div class="lu-drawer__footer"></div>';

    $drawer.querySelector('.lu-drawer__close').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    });

    // Cache refs
    $tabs = $drawer.querySelector('.lu-drawer__tabs');
    $body = $drawer.querySelector('.lu-drawer__body');
    $footer = $drawer.querySelector('.lu-drawer__footer');

    // Tab scroll fade indicators
    $tabs.addEventListener('scroll', updateTabFades);
    updateTabFades();

    document.body.appendChild($overlay);
    document.body.appendChild($drawer);
  }

  function openDrawer() {
    // Force-close any open theme dialogs (cart drawer, account drawer) to prevent double slideout
    var cartComp = document.querySelector('cart-drawer-component');
    if (cartComp && typeof cartComp.closeDialog === 'function') {
      try { cartComp.closeDialog(); } catch (e) {}
    }
    document.querySelectorAll('dialog[open]').forEach(function (d) {
      if (!d.closest('cart-drawer-component')) {
        try { d.close(); } catch (e) {}
      }
    });
    // Refresh state from localStorage (cross-tab sync)
    state = loadState();
    _suggestCache = {};
    buildDrawer();
    renderDrawer();
    $overlay.classList.add('open');
    $drawer.classList.add('open');
    drawerOpen = true;
    document.body.style.overflow = 'hidden';
    trackEvent('lineup_drawer_opened', {});
  }

  function closeDrawer() {
    if (!$drawer) return;
    $overlay.classList.remove('open');
    $drawer.classList.remove('open');
    drawerOpen = false;
    document.body.style.overflow = '';
    // Force-close any theme dialogs that were hidden behind the lineup drawer
    var cartComp = document.querySelector('cart-drawer-component');
    if (cartComp && typeof cartComp.closeDialog === 'function') {
      try { cartComp.closeDialog(); } catch (e) {}
    }
    document.querySelectorAll('dialog[open]').forEach(function (d) {
      if (!d.closest('cart-drawer-component')) {
        try { d.close(); } catch (e) {}
      }
    });
  }

  // ─── DRAWER RENDER (orchestrator) ───
  function renderDrawer() {
    if (!$tabs || !$body || !$footer) return;
    var lineup = getActiveLineup();
    renderTabs();
    renderBody(lineup);
    renderFooter(lineup);
  }

  // ─── DRAWER: TABS ───
  function renderTabs() {
    $tabs.innerHTML = '';
    state.lineups.forEach(function (lineup) {
      var tab = el('button', 'lu-drawer__tab' + (lineup.id === state.activeId ? ' lu-drawer__tab--active' : ''), lineup.festival.name);
      tab.setAttribute('type', 'button');
      tab.addEventListener('click', function () {
        state.activeId = lineup.id;
        saveState();
        renderDrawer();
      });
      $tabs.appendChild(tab);
    });

    // Only show "+ Festival" tab when there are existing lineups
    // (empty state has its own CTA)
    if (state.lineups.length > 0) {
      var addTab = el('button', 'lu-drawer__tab lu-drawer__tab--add', '+ Festival');
      addTab.setAttribute('type', 'button');
      addTab.addEventListener('click', function () {
        openPicker(function () { renderDrawer(); });
      });
      $tabs.appendChild(addTab);
    }

    // Scroll active tab into view
    var activeTab = $tabs.querySelector('.lu-drawer__tab--active');
    if (activeTab) {
      setTimeout(function () {
        activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        updateTabFades();
      }, 50);
    } else {
      updateTabFades();
    }
  }

  function updateTabFades() {
    if (!$tabs) return;
    var wrap = $tabs.parentElement;
    if (!wrap || !wrap.classList.contains('lu-drawer__tabs-wrap')) return;

    var sl = $tabs.scrollLeft;
    var sw = $tabs.scrollWidth;
    var cw = $tabs.clientWidth;

    wrap.classList.toggle('lu-drawer__tabs-wrap--fade-left', sl > 4);
    wrap.classList.toggle('lu-drawer__tabs-wrap--fade-right', sl + cw < sw - 4);
  }

  // ─── DRAWER: BODY ───
  function renderBody(lineup) {
    $body.innerHTML = '';

    if (!lineup) {
      $body.innerHTML = '<div class="lu-empty">' +
        '<div class="lu-empty__icon">&#x1F90D;</div>' +
        '<div class="lu-empty__title">No saved items yet</div>' +
        '<div class="lu-empty__sub">Tap the heart on any item to save it here. Planning for a festival? You can organize your saves into outfit lineups anytime.</div>' +
        '<button class="lu-empty__btn" type="button">+ Plan a festival</button>' +
        '</div>';
      $body.querySelector('.lu-empty__btn').addEventListener('click', function () {
        openPicker(function () { renderDrawer(); });
      });
      return;
    }

    // Festival info bar
    renderFestInfo($body, lineup);

    // Items — grouped by day for multi-day, flat for single-day
    var numDays = getFestivalDays(lineup);
    if (numDays > 1) {
      renderDayGroups($body, lineup, numDays);
    } else {
      renderItemList($body, lineup, lineup.items);
    }

    // Delete link
  }

  // ─── DRAWER: FESTIVAL INFO ───
  function renderFestInfo(container, lineup) {
    var fest = lineup.festival;
    var deadline = fest.orderByQuick;
    var daysLeft = daysUntil(deadline);
    var numDays = getFestivalDays(lineup);

    var info = el('div', 'lu-fest-info');

    // Icon-only link buttons
    var iconLinks = [];
    if (fest.guideUrl) iconLinks.push({ url: fest.guideUrl, label: 'Outfit Guide', ext: false, cls: '',
      svg: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2.7 12.7V3.3A1.3 1.3 0 014 2h8.7v9.3"/><path d="M4 14h9.3V4"/><path d="M4 14a1.3 1.3 0 010-2.7h9.3"/></svg>' });
    if (fest.spotifyUrl) iconLinks.push({ url: fest.spotifyUrl, label: 'Pregame Mix', ext: true, cls: ' lu-fest-icon--spotify',
      svg: '<svg viewBox="0 0 16 16"><path fill="#1DB954" d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8S12.44 0 8 0zm3.68 11.56c-.16.24-.44.32-.68.16-1.88-1.16-4.24-1.4-7.04-.76-.28.08-.52-.12-.6-.36-.08-.28.12-.52.36-.6 3.04-.68 5.68-.4 7.76.88.28.12.32.44.2.68zm.96-2.2c-.2.28-.56.4-.84.2-2.16-1.32-5.44-1.72-7.96-.92-.32.08-.68-.08-.76-.4-.08-.32.08-.68.4-.76C6.4 6.6 10 7.04 12.48 8.56c.24.12.36.52.16.8zm.08-2.24C10.16 5.6 5.88 5.44 3.44 6.2c-.4.12-.8-.12-.92-.48-.12-.4.12-.8.48-.92 2.84-.84 7.52-.68 10.48 1.08.36.2.48.68.28 1.04-.2.28-.68.4-1.04.2z"/></svg>' });
    if (fest.collectionUrl) iconLinks.push({ url: fest.collectionUrl, label: 'Shop Collection', ext: false, cls: '',
      svg: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M4 1.3L2 4.7v9.3a1.3 1.3 0 001.3 1.3h9.4A1.3 1.3 0 0014 14V4.7L12 1.3H4z"/><path d="M2 4.7h12"/><path d="M10.7 7.3a2.7 2.7 0 01-5.4 0"/></svg>' });
    if (fest.ticketUrl) iconLinks.push({ url: fest.ticketUrl, label: 'Get Tickets', ext: true, cls: '',
      svg: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M10 1.3L14.7 6l-8.4 8.4a1.3 1.3 0 01-1.9 0L1.6 11.6a1.3 1.3 0 010-1.9L10 1.3z"/><path d="M7.3 4l4.7 4.7"/><circle cx="10.3" cy="3.7" r=".5" fill="currentColor" stroke="none"/></svg>' });

    var iconsHtml = iconLinks.length ? '<div class="lu-fest-info__icons">' +
      iconLinks.map(function (l) {
        return '<a class="lu-fest-icon' + l.cls + ' lu-fest-icon--labeled" href="' + l.url + '"' +
          (l.ext ? ' target="_blank" rel="noopener"' : '') +
          ' aria-label="' + l.label + '" title="' + l.label + '">' + l.svg + '<span class="lu-fest-icon__label">' + l.label + '</span></a>';
      }).join('') + '</div>' : '';

    var left = '<div>' +
      '<div class="lu-fest-info__name">' + fest.name + '</div>' +
      (fest.location ? '<span class="lu-fest-info__location">' + fest.location + (numDays > 1 ? ' \u00B7 ' + numDays + ' days' : '') + '</span>' : (numDays > 1 ? '<span class="lu-fest-info__location">' + numDays + ' days</span>' : '')) +
      iconsHtml +
      '</div>';
    var right = '<div class="lu-fest-info__right">' +
      (daysLeft ? '<div class="lu-fest-info__deadline">Order by ' + formatDate(deadline) + '</div>' : '') +
      '<button class="lu-fest-info__remove" type="button" aria-label="Remove outfit lineup" title="Remove outfit lineup">' +
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 4h12M5.3 4V2.7a1.3 1.3 0 011.4-1.4h2.6a1.3 1.3 0 011.4 1.4V4M13 4v9.3a1.3 1.3 0 01-1.3 1.4H4.3A1.3 1.3 0 013 13.3V4"/></svg>' +
      '</button></div>';
    info.innerHTML = left + right;

    info.querySelector('.lu-fest-info__remove').addEventListener('click', function () {
      var confirmMsg = isFavoritesLineup(lineup)
        ? 'Clear all your saved Favorites?'
        : 'Remove your ' + lineup.festival.name + ' outfit lineup?';
      if (confirm(confirmMsg)) {
        deleteLineup(lineup.id);
        renderDrawer();
        updateAllSaveButtons();
      }
    });

    container.appendChild(info);
  }

  // ─── DRAWER: DAY GROUPS ───
  function renderDayGroups(container, lineup, numDays) {
    // Group items by day
    var groups = {};
    for (var d = 1; d <= numDays; d++) groups[d] = [];
    groups[0] = []; // unassigned

    lineup.items.forEach(function (item) {
      var day = item.day || 0;
      if (day > numDays) day = 0;
      if (!groups[day]) groups[day] = [];
      groups[day].push(item);
    });

    // For long festivals (>7 days), only show days with items or skipped days
    var isLong = numDays > 7;
    var emptyDayCount = 0;

    for (var day = 1; day <= numDays; day++) {
      var hasItems = groups[day].length > 0;
      var skipped = isDaySkipped(lineup, day);

      if (isLong && !hasItems && !skipped) {
        emptyDayCount++;
        continue;
      }

      // If we skipped some empty days, show a summary row before this day
      if (isLong && emptyDayCount > 0) {
        var summaryEl = el('div', 'lu-day-group lu-day-group--empty-summary');
        summaryEl.innerHTML = '<div class="lu-day-group__header lu-day-group__header--summary">' +
          '<span class="lu-day-group__meta">' + emptyDayCount + ' day' + (emptyDayCount > 1 ? 's' : '') + ' with no outfits planned</span>' +
          '</div>';
        container.appendChild(summaryEl);
        emptyDayCount = 0;
      }

      renderDayGroup(container, lineup, day, groups[day], numDays);
    }

    // Trailing empty days summary
    if (isLong && emptyDayCount > 0) {
      var trailEl = el('div', 'lu-day-group lu-day-group--empty-summary');
      trailEl.innerHTML = '<div class="lu-day-group__header lu-day-group__header--summary">' +
        '<span class="lu-day-group__meta">' + emptyDayCount + ' day' + (emptyDayCount > 1 ? 's' : '') + ' with no outfits planned</span>' +
        '</div>';
      container.appendChild(trailEl);
    }

    // Render unassigned
    if (groups[0].length > 0) {
      renderDayGroup(container, lineup, 0, groups[0], numDays);
    }

    // Empty state for the whole lineup
    if (lineup.items.length === 0) {
      var emptyDiv = el('div', 'lu-empty lu-empty--compact');
      emptyDiv.innerHTML = '<div class="lu-empty__sub">Start adding pieces to your ' + lineup.festival.name + ' outfit lineup</div>' +
        (lineup.festival.collectionUrl ? '<a class="lu-empty__btn" href="' + lineup.festival.collectionUrl + '">Browse Collection</a>' : '<a class="lu-empty__btn" href="/collections/best-sellers">Browse Outfits</a>');
      container.appendChild(emptyDiv);
    }
  }

  function renderDayGroup(container, lineup, dayNum, items, numDays) {
    var skipped = dayNum > 0 && isDaySkipped(lineup, dayNum);
    var group = el('div', 'lu-day-group' + (skipped ? ' lu-day-group--skipped' : ''));
    var subtotal = items.reduce(function (s, i) { return s + (i.price || 0); }, 0);

    var header = el('div', 'lu-day-group__header');
    var labelClass = dayNum === 0 ? 'lu-day-group__label lu-day-group__label--unassigned' : 'lu-day-group__label';

    var metaText = skipped
      ? 'Not attending'
      : items.length + ' piece' + (items.length !== 1 ? 's' : '') + (subtotal ? ' \u00B7 ' + formatPrice(subtotal) : '');

    var skipHtml = '';
    if (dayNum > 0) {
      if (skipped) {
        skipHtml = '<button class="lu-day-group__skip lu-day-group__skip--restore" type="button">Restore</button>';
      } else {
        skipHtml = '<button class="lu-day-group__skip" type="button">Not going</button>';
      }
    }

    header.innerHTML = '<span>' +
      '<span class="' + labelClass + '">' + getDayLabel(lineup, dayNum) + '</span>' +
      ' <span class="lu-day-group__meta">' + metaText + '</span>' +
      '</span>' +
      '<span class="lu-day-group__actions">' + skipHtml + CHEVRON_SVG + '</span>';

    // Skip/restore button handler
    var skipBtn = header.querySelector('.lu-day-group__skip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (skipped) {
          restoreDay(lineup.id, dayNum);
        } else {
          skipDay(lineup.id, dayNum);
        }
        renderDrawer();
        updateAllSaveButtons();
      });
    }

    header.addEventListener('click', function () {
      if (!skipped) group.classList.toggle('lu-day-group--collapsed');
    });
    group.appendChild(header);

    if (!skipped) {
      var itemsContainer = el('div', 'lu-day-group__items');

      // Render existing items first
      items.forEach(function (item) {
        var itemEl = buildItemCard(lineup, item, numDays);
        itemsContainer.appendChild(itemEl);
      });

      // Always show suggestions below items (for any real day)
      if (dayNum > 0) {
        var sugWrap = el('div', 'lu-suggestions');
        sugWrap.innerHTML = '<div class="lu-suggestions__label">Suggested for you</div>' +
          '<div class="lu-suggestions__scroll">' +
            '<div class="lu-suggestion-card lu-suggestion-card--skeleton"></div>' +
            '<div class="lu-suggestion-card lu-suggestion-card--skeleton"></div>' +
            '<div class="lu-suggestion-card lu-suggestion-card--skeleton"></div>' +
          '</div>';
        itemsContainer.appendChild(sugWrap);
        (function (wrap, lid, dn) {
          fetchSuggestions(lineup, function (products) {
            renderSuggestionRow(wrap, lid, dn, products);
          });
        })(sugWrap, lineup.id, dayNum);
      }

      group.appendChild(itemsContainer);
    }

    container.appendChild(group);
  }

  // ─── SMART SUGGESTION SCORING ENGINE ───

  var _INTEL_DEFAULT = {
    slotKeywords: {
      top: ['top', 'crop', 'bra', 'halter', 'bandeau', 'bustier', 'bodysuit', 'tank', 'tee', 'shirt', 'vest', 'corset'],
      bottom: ['bottom', 'pant', 'short', 'skirt', 'bell', 'flare', 'legging', 'chap', 'brief'],
      hosiery: ['hosiery', 'tight', 'stocking', 'sock', 'fishnet', 'thigh-high', 'leg-wrap'],
      sleeves: ['sleeve', 'arm-warmer', 'glove', 'arm warmer', 'shrug', 'bolero'],
      accessory: ['accessory', 'hat', 'bag', 'fanny', 'bandana', 'mask', 'choker', 'necklace', 'earring', 'pasty', 'pasties', 'wing', 'harness', 'fan', 'sunglasses', 'goggles']
    },
    vibeMap: {},
    colorHarmony: [
      ['black', 'silver', 'white', 'holographic'],
      ['pink', 'purple', 'magenta', 'fuchsia'],
      ['blue', 'teal', 'cyan', 'turquoise'],
      ['red', 'orange', 'yellow', 'gold'],
      ['green', 'lime', 'neon-green', 'emerald'],
      ['rainbow', 'multi', 'tie-dye', 'iridescent']
    ]
  };

  function loadIntel(callback) {
    if (_intelConfig) {
      return callback(_intelConfig);
    }
    // Shopify serves theme assets at /assets/filename
    fetch('/assets/lineup-intel.json')
      .then(function (r) {
        if (!r.ok) throw new Error('Intel fetch failed');
        return r.json();
      })
      .then(function (data) {
        _intelConfig = data || _INTEL_DEFAULT;
        // Merge defaults for any missing keys
        if (!_intelConfig.slotKeywords) _intelConfig.slotKeywords = _INTEL_DEFAULT.slotKeywords;
        if (!_intelConfig.vibeMap) _intelConfig.vibeMap = _INTEL_DEFAULT.vibeMap;
        if (!_intelConfig.colorHarmony) _intelConfig.colorHarmony = _INTEL_DEFAULT.colorHarmony;
        callback(_intelConfig);
      })
      .catch(function () {
        _intelConfig = _INTEL_DEFAULT;
        callback(_intelConfig);
      });
  }

  function getTagValues(product, prefix) {
    var tags = product.tags || [];
    var vals = [];
    var prefixLower = prefix.toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i].toLowerCase();
      if (t.indexOf(prefixLower) === 0) {
        vals.push(t.slice(prefixLower.length));
      }
    }
    return vals;
  }

  function classifyProduct(product, slotKeywords) {
    var slots = ['top', 'bottom', 'hosiery', 'sleeves', 'accessory'];
    var tags = product.tags || [];
    var tagsLower = tags.map(function (t) { return t.toLowerCase(); });

    // 1. Check for slot: enrichment tag first — direct hit
    for (var t = 0; t < tagsLower.length; t++) {
      if (tagsLower[t].indexOf('slot:') === 0) {
        var enrichedSlot = tagsLower[t].slice(5);
        if (slots.indexOf(enrichedSlot) !== -1) return enrichedSlot;
        // Map bodysuit/dress/skirt to broader slots
        if (enrichedSlot === 'bodysuit' || enrichedSlot === 'dress') return 'top';
        if (enrichedSlot === 'skirt') return 'bottom';
      }
    }

    // Word boundary match helper — matches whole words only
    function matchesKeyword(text, keyword) {
      var re = new RegExp('\\b' + keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b');
      return re.test(text);
    }

    var titleLower = (product.title || '').toLowerCase();
    var handleLower = (product.handle || '').toLowerCase();

    // 2. Check product title only (most reliable signal)
    for (var s = 0; s < slots.length; s++) {
      var slot = slots[s];
      var keywords = slotKeywords[slot] || [];
      for (var k = 0; k < keywords.length; k++) {
        if (matchesKeyword(titleLower, keywords[k])) return slot;
      }
    }

    // 3. Check handle as fallback
    for (var s2 = 0; s2 < slots.length; s2++) {
      var slot2 = slots[s2];
      var keywords2 = slotKeywords[slot2] || [];
      for (var k2 = 0; k2 < keywords2.length; k2++) {
        if (matchesKeyword(handleLower, keywords2[k2])) return slot2;
      }
    }

    // 4. Check remaining tags last
    var tagText = tagsLower.join(' ');
    for (var s3 = 0; s3 < slots.length; s3++) {
      var slot3 = slots[s3];
      var keywords3 = slotKeywords[slot3] || [];
      for (var k3 = 0; k3 < keywords3.length; k3++) {
        if (matchesKeyword(tagText, keywords3[k3])) return slot3;
      }
    }

    return 'unknown';
  }

  function scoreProducts(products, lineup, dayNum, intel) {
    var slotKeywords = intel.slotKeywords || _INTEL_DEFAULT.slotKeywords;
    var vibeMap = intel.vibeMap || {};
    var colorHarmony = intel.colorHarmony || _INTEL_DEFAULT.colorHarmony;

    // Gather items already in this lineup for this day
    var dayItems = lineup.items.filter(function (i) { return i.day === dayNum; });
    // Also gather all lineup items for cross-day analysis
    var allItems = lineup.items;

    // Determine which outfit slots are already filled for this day
    var filledSlots = {};
    var dayTags = [];
    var dayColors = [];
    var dayPrices = [];
    dayItems.forEach(function (item) {
      // Classify item by its tags/title/handle (items in lineup have handle + title)
      var fakeProduct = { tags: item.tags || [], title: item.title || '', handle: item.handle || '' };
      var slot = classifyProduct(fakeProduct, slotKeywords);
      if (slot !== 'unknown') filledSlots[slot] = true;
      // Collect tags from existing items
      var itemTags = item.tags || [];
      for (var t = 0; t < itemTags.length; t++) {
        dayTags.push(itemTags[t].toLowerCase());
      }
      // Collect colors
      if (item.tags) {
        var fakeP = { tags: item.tags };
        var cols = getTagValues(fakeP, 'color:');
        for (var c = 0; c < cols.length; c++) dayColors.push(cols[c]);
      }
      if (item.price) dayPrices.push(item.price);
    });

    // Determine missing slots
    var missingSlots = [];
    var coreSlots = ['top', 'bottom'];
    for (var ms = 0; ms < coreSlots.length; ms++) {
      if (!filledSlots[coreSlots[ms]]) missingSlots.push(coreSlots[ms]);
    }

    // Get festival slug for vibe matching
    var festSlug = (lineup.festival && lineup.festival.slug) ? lineup.festival.slug.toLowerCase() : '';
    var festVibes = (vibeMap[festSlug] || []).map(function (v) { return v.toLowerCase(); });

    // Avg price for price proximity scoring
    var avgPrice = 0;
    if (dayPrices.length > 0) {
      var priceSum = 0;
      for (var pp = 0; pp < dayPrices.length; pp++) priceSum += dayPrices[pp];
      avgPrice = priceSum / dayPrices.length;
    }

    // Score each product
    var scored = products.map(function (product, idx) {
      var score = 0;
      var slotLabel = '';
      var candidateSlot = classifyProduct(product, slotKeywords);

      // 1. Outfit gap (40pts) + item-count-aware boosting
      var dayItemCount = dayItems.length;
      if (candidateSlot !== 'unknown' && missingSlots.indexOf(candidateSlot) !== -1) {
        score += 40;
        slotLabel = candidateSlot;
      } else if (candidateSlot !== 'unknown' && !filledSlots[candidateSlot]) {
        // Not a core missing slot, but an unfilled complementary slot
        score += 20;
        slotLabel = candidateSlot;
      }
      // At 4+ items, heavily boost accessories/hosiery (finishing touches)
      if (dayItemCount >= 4 && (candidateSlot === 'accessory' || candidateSlot === 'hosiery' || candidateSlot === 'sleeves')) {
        score += 30;
      } else if (dayItemCount >= 2 && (candidateSlot === 'accessory' || candidateSlot === 'hosiery' || candidateSlot === 'sleeves')) {
        score += 15;
      }

      // 2. Print/collection match (25pts)
      if (dayTags.length > 0) {
        var candidateTags = (product.tags || []).map(function (t) { return t.toLowerCase(); });
        for (var ct = 0; ct < candidateTags.length; ct++) {
          var tag = candidateTags[ct];
          // Skip enrichment prefix tags (color:, vibe:, etc.)
          if (tag.indexOf(':') !== -1) continue;
          if (dayTags.indexOf(tag) !== -1) {
            score += 25;
            break;
          }
        }
      }

      // 3. Vibe match (20pts)
      if (festVibes.length > 0) {
        var productVibes = getTagValues(product, 'vibe:');
        for (var pv = 0; pv < productVibes.length; pv++) {
          if (festVibes.indexOf(productVibes[pv]) !== -1) {
            score += 20;
            break;
          }
        }
      } else if (festSlug) {
        // Fallback: match festival slug against product tags/title
        var searchable = ((product.tags || []).join(' ') + ' ' + product.title).toLowerCase();
        if (searchable.indexOf(festSlug) !== -1) {
          score += 10;
        }
      }

      // 4. Color harmony (15pts)
      if (dayColors.length > 0) {
        var candidateColors = getTagValues(product, 'color:');
        for (var cc = 0; cc < candidateColors.length; cc++) {
          var matched = false;
          for (var g = 0; g < colorHarmony.length; g++) {
            var group = colorHarmony[g];
            if (group.indexOf(candidateColors[cc]) !== -1) {
              for (var dc = 0; dc < dayColors.length; dc++) {
                if (group.indexOf(dayColors[dc]) !== -1) {
                  score += 15;
                  matched = true;
                  break;
                }
              }
            }
            if (matched) break;
          }
          if (matched) break;
        }
      }

      // 5. Price proximity (10pts)
      if (avgPrice > 0 && product.price > 0) {
        var priceDist = Math.abs(product.price - avgPrice);
        var maxDist = avgPrice; // normalize to avg price
        var priceScore = Math.max(0, 10 - Math.round((priceDist / (maxDist || 1)) * 10));
        score += priceScore;
      } else if (avgPrice === 0 && product.price > 0) {
        // No items yet — favor mid-range products ($25-$60)
        var midRange = product.price >= 2500 && product.price <= 6000;
        score += midRange ? 10 : 5;
      }

      // 6. Day variety (10pts)
      var totalProducts = products.length || 1;
      var variedIdx = (idx + dayNum * 3) % totalProducts;
      var distFromTarget = Math.abs(idx - variedIdx);
      var varietyScore = Math.max(0, 10 - distFromTarget);
      score += varietyScore;

      return { product: product, score: score, slotLabel: slotLabel };
    });

    // Single sorted list — gap-fill bonus is already in the score (+40pts),
    // so coordinating pieces rank higher naturally without hard partitioning
    scored.sort(function (a, b) { return b.score - a.score; });

    // Per-day variety: offset into the sorted array so each day sees different products
    var offset = ((dayNum - 1) * 4) % (scored.length || 1);
    var merged = scored.slice(offset).concat(scored.slice(0, offset));

    // Attach metadata to products
    var result = [];
    for (var r = 0; r < merged.length; r++) {
      var p = merged[r].product;
      p._score = merged[r].score;
      p._slotLabel = merged[r].slotLabel;
      result.push(p);
    }
    return { products: result, missingSlots: missingSlots };
  }

  // ─── DRAWER: SUGGESTIONS FOR EMPTY DAYS ───
  function fetchSuggestions(lineup, callback) {
    var lid = lineup.id;
    // Return cached if fresh (< 5 min)
    if (_suggestCache[lid] && Date.now() - _suggestCache[lid].ts < 300000) {
      return callback(_suggestCache[lid].products);
    }
    // Queue if already fetching
    if (_suggestFetching[lid]) {
      _suggestFetching[lid].push(callback);
      return;
    }
    _suggestFetching[lid] = [callback];

    // Determine collection handle from lineup festival
    var collUrl = lineup.festival.collectionUrl || '';
    var handle = collUrl.split('/collections/')[1] || '';
    if (handle) handle = handle.split('?')[0].split('#')[0];

    var url = handle
      ? '/collections/' + handle + '/products.json?limit=24'
      : '/collections/best-sellers/products.json?limit=24';

    fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      var products = (data.products || []).map(function (p) {
        var img = (p.images && p.images[0] && p.images[0].src) || '';
        // Shopify CDN resize for thumbnails
        if (img) img = img.replace(/\.([a-z]+)\?/, '_180x180_crop_center.$1?');
        // Normalize tags: Shopify returns comma-separated string or array
        var rawTags = p.tags || '';
        var tagsArr = typeof rawTags === 'string'
          ? rawTags.split(',').map(function (t) { return t.trim(); }).filter(Boolean)
          : (Array.isArray(rawTags) ? rawTags : []);
        return {
          id: String(p.id),
          handle: p.handle || '',
          title: p.title || '',
          price: p.variants && p.variants[0] ? Math.round(parseFloat(p.variants[0].price) * 100) : 0,
          image: img,
          url: '/products/' + (p.handle || ''),
          tags: tagsArr,
          available: (p.variants || []).some(function (v) { return v.available; }),
        };
      });
      _suggestCache[lid] = { products: products, ts: Date.now() };
      // Pre-load intel in parallel so it's ready for scoring
      loadIntel(function () {
        var cbs = _suggestFetching[lid] || [];
        delete _suggestFetching[lid];
        cbs.forEach(function (cb) { cb(products); });
      });
    }).catch(function () {
      // Fallback to best sellers if collection fails
      if (handle) {
        lineup.festival.collectionUrl = '';
        fetchSuggestions(lineup, callback);
      } else {
        var cbs = _suggestFetching[lid] || [];
        delete _suggestFetching[lid];
        cbs.forEach(function (cb) { cb([]); });
      }
    });
  }

  function renderSuggestionRow(wrap, lineupId, dayNum, products) {
    var lineup = state.lineups.find(function (l) { return l.id === lineupId; });
    if (!lineup) return;

    // Filter out products already in this lineup
    var savedIds = {};
    lineup.items.forEach(function (i) { savedIds[String(i.productId)] = true; });
    var available = products.filter(function (p) { return !savedIds[p.id] && p.available; });

    wrap.innerHTML = '';

    if (available.length === 0) {
      var browseUrl = lineup.festival.collectionUrl || '/collections/best-sellers';
      wrap.innerHTML = '<div class="lu-empty lu-empty--compact">' +
        '<div class="lu-empty__sub">No outfits planned yet</div>' +
        '<a class="lu-empty__btn" href="' + browseUrl + '">Browse Outfits</a></div>';
      return;
    }

    // Score and rank suggestions using intel engine
    var intel = _intelConfig || _INTEL_DEFAULT;
    var scored = scoreProducts(available, lineup, dayNum, intel);
    var ranked = scored.products;
    var missingSlots = scored.missingSlots;

    // Adaptive label based on how many items are on this day
    var dayItemCount = lineup.items.filter(function (i) { return i.day === dayNum; }).length;
    var labelText;
    if (dayItemCount === 0) {
      labelText = 'Start your Day ' + dayNum + ' look';
    } else if (dayItemCount === 1) {
      labelText = 'Complete your Day ' + dayNum + ' look';
    } else if (dayItemCount <= 3) {
      labelText = 'Add more to Day ' + dayNum;
    } else {
      labelText = 'Finishing touches for Day ' + dayNum;
    }

    var label = el('div', 'lu-suggestions__label', labelText);
    wrap.appendChild(label);

    var scroll = el('div', 'lu-suggestions__scroll');

    // Show top 8 scored suggestions
    var shown = ranked.slice(0, 8);
    shown.forEach(function (product) {
      var card = buildSuggestionCard(lineupId, product, dayNum);
      scroll.appendChild(card);
    });

    // Browse more link at end
    var browseUrl = lineup.festival.collectionUrl || '/collections/best-sellers';
    var browseCard = el('a', 'lu-suggestions__browse', 'Browse<br>More →');
    browseCard.href = browseUrl;
    scroll.appendChild(browseCard);

    wrap.appendChild(scroll);
  }

  function buildSuggestionCard(lineupId, product, dayNum) {
    var card = el('div', 'lu-suggestion-card');
    card.innerHTML =
      '<img class="lu-suggestion-card__img" src="' + (product.image || '') + '" alt="" loading="lazy">' +
      '<div class="lu-suggestion-card__title">' + (product.title || '') + '</div>' +
      '<div class="lu-suggestion-card__price">' + formatPrice(product.price) + '</div>' +
      '<button class="lu-suggestion-card__add" type="button" aria-label="Add to lineup">+</button>';

    card.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (card.classList.contains('lu-suggestion-card--adding')) return;
      card.classList.add('lu-suggestion-card--adding');

      var added = addItem(lineupId, product, dayNum);
      if (added) {
        trackEvent('lineup_suggestion_added', {
          product_id: product.id || '',
          handle: product.handle || '',
          day: dayNum,
        });
        card.classList.add('lu-suggestion-card--added');
        updateAllSaveButtons();
        updateNavCount();
        // After animation, re-render the drawer to show the new item
        setTimeout(function () {
          renderDrawer();
        }, 350);
      } else {
        card.classList.remove('lu-suggestion-card--adding');
      }
    });

    return card;
  }

  // ─── DRAWER: ITEM LIST (single-day festivals) ───
  function renderItemList(container, lineup, items) {
    if (items.length === 0) {
      var sugWrap = el('div', 'lu-suggestions');
      sugWrap.innerHTML = '<div class="lu-suggestions__label">Complete your look</div>' +
        '<div class="lu-suggestions__scroll">' +
          '<div class="lu-suggestion-card lu-suggestion-card--skeleton"></div>' +
          '<div class="lu-suggestion-card lu-suggestion-card--skeleton"></div>' +
          '<div class="lu-suggestion-card lu-suggestion-card--skeleton"></div>' +
        '</div>';
      container.appendChild(sugWrap);
      fetchSuggestions(lineup, function (products) {
        renderSuggestionRow(sugWrap, lineup.id, 0, products);
      });
      return;
    }

    items.forEach(function (item) {
      container.appendChild(buildItemCard(lineup, item, 1));
    });
  }

  // ─── DRAWER: SINGLE ITEM CARD ───
  function buildItemCard(lineup, item, numDays) {
    var itemEl = el('div', 'lu-item');
    itemEl.innerHTML = '<img class="lu-item__img" src="' + item.image + '" alt="">' +
      '<div class="lu-item__info">' +
      '<div class="lu-item__name">' + item.title + '</div>' +
      '<div class="lu-item__meta">' + (item.size ? 'Size ' + item.size + ' \u00B7 ' : '') + item.handle + '</div>' +
      '<div class="lu-item__price">' + formatPrice(item.price) + '</div>' +
      (numDays > 1 ? '<button class="lu-item__move" type="button">Move to\u2026</button>' : '') +
      '</div>' +
      '<button class="lu-item__remove" type="button" aria-label="Remove">&times;</button>';

    itemEl.querySelector('.lu-item__remove').addEventListener('click', function () {
      removeItem(lineup.id, item.productId);
      renderDrawer();
      updateAllSaveButtons();
    });

    itemEl.querySelector('.lu-item__img').addEventListener('click', function () {
      if (item.url) window.location.href = item.url;
    });

    // Move-to action for multi-day
    var moveBtn = itemEl.querySelector('.lu-item__move');
    if (moveBtn) {
      moveBtn.addEventListener('click', function () {
        showInlineDayPicker(itemEl, lineup, item, numDays);
      });
    }

    return itemEl;
  }

  // ─── DRAWER: INLINE DAY PICKER (move item between days) ───
  function showInlineDayPicker(itemEl, lineup, item, numDays) {
    var existing = itemEl.querySelector('.lu-day-chips');
    if (existing) { existing.remove(); return; }

    var chips = el('div', 'lu-day-chips');
    for (var d = 1; d <= numDays; d++) {
      (function (dayNum) {
        if (isDaySkipped(lineup, dayNum)) return;
        var chip = el('button', 'lu-day-chips__chip' + (item.day === dayNum ? ' lu-day-chips__chip--active' : ''));
        chip.textContent = 'Day ' + dayNum;
        chip.setAttribute('type', 'button');
        chip.addEventListener('click', function () {
          moveItem(lineup.id, item.productId, dayNum);
          renderDrawer();
        });
        chips.appendChild(chip);
      })(d);
    }

    var noDay = el('button', 'lu-day-chips__chip' + (item.day === 0 ? ' lu-day-chips__chip--active' : ''));
    noDay.textContent = 'Just packing';
    noDay.setAttribute('type', 'button');
    noDay.addEventListener('click', function () {
      moveItem(lineup.id, item.productId, 0);
      renderDrawer();
    });
    chips.appendChild(noDay);

    // Move to another festival
    var moveFest = el('button', 'lu-day-chips__chip lu-day-chips__chip--festival', '\u2192 Another festival');
    moveFest.setAttribute('type', 'button');
    moveFest.addEventListener('click', function () {
      openPicker(function (newLineup) {
        if (newLineup.id === lineup.id) return;
        // Add to new lineup
        var product = { id: item.productId, handle: item.handle, title: item.title, price: item.price, image: item.image, url: item.url };
        var newDays = getFestivalDays(newLineup);
        if (newDays > 1) {
          showDayPicker(newLineup, product, function (day) {
            addItem(newLineup.id, product, day);
            removeItem(lineup.id, item.productId);
            renderDrawer();
            updateAllSaveButtons();
            showToast('Moved to <span class="lu-accent">' + newLineup.festival.name + '</span>', 2500);
          });
        } else {
          addItem(newLineup.id, product, 0);
          removeItem(lineup.id, item.productId);
          renderDrawer();
          updateAllSaveButtons();
          showToast('Moved to <span class="lu-accent">' + newLineup.festival.name + '</span>', 2500);
        }
      });
    });
    chips.appendChild(moveFest);

    itemEl.querySelector('.lu-item__info').appendChild(chips);
  }

  // ─── ADD TO CART ───
  function addItemsToCart(items, btn) {
    if (!items.length) return;
    var origText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    // Fetch variant IDs for each item
    var fetches = items.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variants = product.variants || [];
          var match = null;
          if (item.size) {
            match = variants.find(function (v) {
              return v.available && v.title.indexOf(item.size) !== -1;
            });
          }
          if (!match) {
            match = variants.find(function (v) { return v.available; });
          }
          return match ? { id: match.id, quantity: 1 } : null;
        })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      var cartItems = results.filter(function (r) { return r !== null; });
      if (!cartItems.length) {
        btn.textContent = 'No items available';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
        return;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });
    }).then(function (resp) {
      if (resp && resp.ok) {
        btn.textContent = 'Added \u2713';
        // Re-fetch cart and dispatch theme-native cart:update event
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'lineup', data: { source: 'lineup', itemCount: cart.item_count } }
          }));
        });
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
      } else if (resp) {
        btn.textContent = 'Error \u2014 try again';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
      }
    }).catch(function () {
      btn.textContent = 'Error \u2014 try again';
      setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
    });
  }

  function addItemsToCartAndCheckout(items, btn) {
    if (!items.length) return;
    var origText = btn.textContent;
    btn.textContent = 'Adding\u2026';
    btn.disabled = true;

    var fetches = items.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variants = product.variants || [];
          var match = null;
          if (item.size) {
            match = variants.find(function (v) {
              return v.available && v.title.indexOf(item.size) !== -1;
            });
          }
          if (!match) {
            match = variants.find(function (v) { return v.available; });
          }
          return match ? { id: match.id, quantity: 1 } : null;
        })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      var cartItems = results.filter(function (r) { return r !== null; });
      if (!cartItems.length) {
        btn.textContent = 'No items available';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
        return;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });
    }).then(function (resp) {
      if (resp && resp.ok) {
        // Track each item carted + checkout intent from lineup
        cartItems.forEach(function (ci) {
          trackEvent('lineup_item_carted', { variant_id: ci.id, source: 'checkout' });
        });
        trackEvent('lineup_checkout', {
          item_count: cartItems.length,
          total_cents: items.reduce(function (s, i) { return s + (i.price || 0); }, 0),
        });
        // Flush beacon before navigating away
        beaconFlush();
        window.location.href = '/checkout';
      } else if (resp) {
        btn.textContent = 'Error \u2014 try again';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
      }
    }).catch(function () {
      btn.textContent = 'Error \u2014 try again';
      setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
    });
  }

  // ─── DRAWER: FOOTER ───
  function renderFooter(lineup) {
    if (!lineup) {
      $footer.innerHTML = '';
      return;
    }

    // Exclude items on skipped days from totals
    var activeItems = lineup.items.filter(function (i) {
      return !isDaySkipped(lineup, i.day || 0);
    });
    var total = activeItems.reduce(function (sum, i) { return sum + (i.price || 0); }, 0);
    var budget = getBudgetMode();

    var checkoutBtn = activeItems.length > 0
      ? '<button class="lu-drawer__btn lu-drawer__btn--primary" type="button" data-action="checkout">Checkout \u2192</button>'
      : '';

    $footer.innerHTML = '<div class="lu-drawer__stats">' +
      '<span><strong>' + activeItems.length + '</strong> piece' + (activeItems.length !== 1 ? 's' : '') + '</span>' +
      '<span class="lu-drawer__total">' + formatPrice(total) + '</span>' +
      '</div>' +
      (budget ? '<div class="lu-drawer__budget">Budget: ' + formatPrice(budget.amount || budget.budget || 0) + '</div>' : '') +
      '<div class="lu-drawer__actions">' +
      '<button class="lu-drawer__btn lu-drawer__btn--secondary" type="button" data-action="shop">Continue Shopping</button>' +
      checkoutBtn +
      '</div>';

    $footer.querySelector('[data-action="shop"]').addEventListener('click', closeDrawer);

    var checkoutEl = $footer.querySelector('[data-action="checkout"]');
    if (checkoutEl) {
      checkoutEl.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addItemsToCartAndCheckout(activeItems, checkoutEl);
      });
    }
  }

  // ─── FESTIVAL PICKER MODAL ───
  var pickerOverlayEl = null;
  var pickerFilter = null; // null = show all, 'upcoming' | 'club' | 'later'

  function openPicker(onSelect) {
    if (pickerOverlayEl) {
      pickerOverlayEl.remove();
      pickerOverlayEl = null;
    }

    pickerOverlayEl = el('div', 'lu-picker-overlay');
    pickerFilter = null;

    var picker = el('div', 'lu-picker');
    picker.innerHTML = '<div class="lu-picker__header">' +
      '<span class="lu-picker__title">Choose an Event</span>' +
      '<button class="lu-picker__close" type="button">&times;</button>' +
      '</div>' +
      '<div class="lu-picker__search">' +
      '<div class="lu-picker__search-wrap">' +
      '<span class="lu-picker__search-icon">' + SEARCH_SVG + '</span>' +
      '<input class="lu-picker__input" type="text" placeholder="Search events, artists, genres..." />' +
      '</div></div>' +
      '<div class="lu-picker__filters"></div>' +
      '<div class="lu-picker__list"></div>';

    pickerOverlayEl.appendChild(picker);
    pickerOverlayEl._onSelect = onSelect; // store for CDN race-condition re-render
    document.body.appendChild(pickerOverlayEl);

    var listEl = picker.querySelector('.lu-picker__list');

    picker.querySelector('.lu-picker__close').addEventListener('click', closePicker);
    pickerOverlayEl.addEventListener('click', function (e) {
      if (e.target === pickerOverlayEl) closePicker();
    });

    var input = picker.querySelector('.lu-picker__input');
    input.addEventListener('input', function () {
      renderFestivalList(listEl, input.value.trim(), onSelect);
    });

    renderFestivalList(listEl, '', onSelect);

    void pickerOverlayEl.offsetWidth;
    pickerOverlayEl.classList.add('open');
    pickerOpen = true;
    setTimeout(function () { input.focus({ preventScroll: true }); }, 50);
  }

  function closePicker() {
    if (pickerOverlayEl) {
      pickerOverlayEl.classList.remove('open');
      setTimeout(function () {
        if (pickerOverlayEl) {
          pickerOverlayEl.remove();
          pickerOverlayEl = null;
        }
      }, 350);
    }
    pickerOpen = false;
  }

  function renderFestivalList(listEl, query, onSelect) {
    listEl.innerHTML = '';

    var q = query.toLowerCase();
    var existingSlugs = state.lineups.map(function (l) { return l.festival.slug; });
    var now = new Date();

    // Fuse.js fuzzy search (replaces fragile indexOf chain)
    var matched;
    if (q && fuseInstance) {
      matched = fuseInstance.search(q).map(function(r) { return r.item; });
    } else {
      matched = FESTIVALS.slice();
    }

    var festivals = [];
    var clubNights = [];

    matched.forEach(function (f) {
      var start = new Date(f.start + 'T00:00:00');
      var days = Math.ceil((start - now) / 86400000);
      if (days < 3) return;
      f._days = days;
      f._alreadyAdded = existingSlugs.indexOf(f.slug) >= 0;

      if (f.tier === 'local' || f.eventType === 'club_night') {
        clubNights.push(f);
      } else {
        festivals.push(f);
      }
    });

    festivals.sort(function (a, b) { return a._days - b._days; });
    clubNights.sort(function (a, b) { return a._days - b._days; });

    // Filter pills
    var filtersEl = listEl.parentNode.querySelector('.lu-picker__filters');
    if (filtersEl) {
      filtersEl.innerHTML = '';
      var sections = [];
      if (festivals.length) sections.push({ id: 'festivals', label: 'Upcoming Festivals', count: festivals.length });
      if (clubNights.length) sections.push({ id: 'club', label: 'Club Nights', count: clubNights.length });

      if (sections.length > 1) {
        sections.forEach(function (s) {
          var pill = el('button', 'lu-picker__filter' + (pickerFilter === s.id ? ' lu-picker__filter--active' : ''));
          pill.setAttribute('type', 'button');
          pill.innerHTML = s.label + ' <span class="lu-picker__filter-count">' + s.count + '</span>';
          pill.addEventListener('click', function () {
            pickerFilter = pickerFilter === s.id ? null : s.id;
            var input = listEl.parentNode.querySelector('.lu-picker__input');
            renderFestivalList(listEl, input ? input.value.trim() : '', onSelect);
          });
          filtersEl.appendChild(pill);
        });
      }
    }

    // Apply active filter — search overrides filter (show all sections when querying)
    var showFestivals = q || !pickerFilter || pickerFilter === 'festivals';
    var showClub = q || !pickerFilter || pickerFilter === 'club';

    var SECTION_CAP = 6;

    function appendSection(label, items) {
      listEl.appendChild(el('div', 'lu-picker__group-label', label));
      var limit = (pickerFilter || q) ? items.length : SECTION_CAP;
      for (var i = 0; i < Math.min(limit, items.length); i++) {
        listEl.appendChild(buildFestivalRow(items[i], onSelect));
      }
      if (items.length > limit) {
        var more = el('button', 'lu-picker__see-more', 'See ' + (items.length - limit) + ' more');
        more.setAttribute('type', 'button');
        more.addEventListener('click', function () {
          var parent = more.parentNode;
          for (var j = limit; j < items.length; j++) {
            parent.insertBefore(buildFestivalRow(items[j], onSelect), more);
          }
          more.remove();
        });
        listEl.appendChild(more);
      }
    }

    if (festivals.length && showFestivals) appendSection('Upcoming Festivals', festivals);
    if (clubNights.length && showClub) appendSection('Club Nights', clubNights);

    if (!festivals.length && !clubNights.length && q) {
      listEl.appendChild(el('div', 'lu-picker__no-results', 'No events match \u201C' + q + '\u201D'));
      // Prompt to create custom event when search has no results
      var inlineCustom = el('div', 'lu-picker__custom lu-picker__custom--inline', '+ Create \u201C' + q + '\u201D as a Custom Event');
      inlineCustom.addEventListener('click', function () { showCustomForm(listEl, onSelect); });
      listEl.appendChild(inlineCustom);
    }
  }

  function buildFestivalRow(f, onSelect) {
    var row = el('div', 'lu-picker__item' + (f._alreadyAdded ? ' lu-picker__item--selected' : ''));

    var badge = '';
    if (f._alreadyAdded) {
      badge = '<span class="lu-picker__item-badge lu-picker__item-badge--added">Added</span>';
    } else if (f._days <= 30) {
      badge = '<span class="lu-picker__item-badge lu-picker__item-badge--soon">' + f._days + 'd away</span>';
    }

    var dateRange = formatDate(f.start);
    if (f.end && f.end !== f.start) dateRange += ' \u2013 ' + formatDate(f.end);

    var isClub = f.tier === 'local' || f.eventType === 'club_night';
    var metaParts = dateRange;
    if (isClub && f.venue) {
      metaParts += ' \u00B7 ' + f.venue + (f.location ? ', ' + f.location.split(',')[0] : '');
    } else if (f.location) {
      metaParts += ' \u00B7 ' + f.location;
    }

    var clubDot = isClub ? '<span class="lu-picker__club-dot"></span>' : '';

    row.innerHTML = '<div class="lu-picker__item-info">' +
      '<div class="lu-picker__item-name">' + clubDot + f.name + '</div>' +
      '<div class="lu-picker__item-meta">' + metaParts + '</div>' +
      '</div>' + badge;

    if (!f._alreadyAdded) {
      row.style.cursor = 'pointer';
      row.addEventListener('click', function () {
        var lineup = createLineup(f);
        closePicker();
        if (typeof onSelect === 'function') onSelect(lineup);
        showToast('Created <span class="lu-accent">' + f.name + '</span> outfit lineup');
        if (drawerOpen) renderDrawer();
        updateAllSaveButtons();
      });
    } else {
      // Already added — click to toggle inline confirm within the row
      row.style.cursor = 'pointer';
      row.addEventListener('click', function () {
        // If confirm is already showing, ignore (buttons handle it)
        if (row.querySelector('.lu-inline-confirm')) return;

        var lineup = state.lineups.find(function (l) { return l.festival.slug === f.slug; });
        if (!lineup) return;

        if (lineup.items.length > 0) {
          // Has items — swap row content to inline confirmation
          var itemCount = lineup.items.length;
          var origHtml = row.innerHTML;
          row.classList.add('lu-picker__item--confirming');
          row.innerHTML =
            '<div class="lu-picker__item-info">' +
              '<div class="lu-picker__item-name">Remove ' + f.name + '?</div>' +
              '<div class="lu-picker__item-meta">' + itemCount + ' piece' + (itemCount > 1 ? 's' : '') + ' will be unassigned</div>' +
            '</div>' +
            '<div class="lu-inline-confirm__actions">' +
              '<button class="lu-inline-confirm__btn lu-inline-confirm__btn--remove" type="button">Remove</button>' +
              '<button class="lu-inline-confirm__btn lu-inline-confirm__btn--keep" type="button">Keep</button>' +
            '</div>';

          row.querySelector('.lu-inline-confirm__btn--remove').addEventListener('click', function (e) {
            e.stopPropagation();
            deleteLineup(lineup.id);
            showToast('Removed <span class="lu-accent">' + f.name + '</span> outfit lineup');
            updateAllSaveButtons();
            var listEl = row.closest('.lu-picker__list');
            var input = document.querySelector('.lu-picker__input');
            if (listEl) renderFestivalList(listEl, input ? input.value.trim() : '', onSelect);
          });

          row.querySelector('.lu-inline-confirm__btn--keep').addEventListener('click', function (e) {
            e.stopPropagation();
            row.classList.remove('lu-picker__item--confirming');
            row.innerHTML = origHtml;
          });
        } else {
          // Empty lineup — just delete
          deleteLineup(lineup.id);
          showToast('Removed <span class="lu-accent">' + f.name + '</span> outfit lineup');
          updateAllSaveButtons();
          var listEl = row.closest('.lu-picker__list');
          var input = document.querySelector('.lu-picker__input');
          if (listEl) renderFestivalList(listEl, input ? input.value.trim() : '', onSelect);
        }
      });
    }

    return row;
  }

  function showCustomForm(listEl, onSelect) {
    var existing = listEl.querySelector('.lu-custom-form');
    if (existing) { existing.classList.toggle('open'); return; }

    var form = el('div', 'lu-custom-form open');
    form.innerHTML = '<label>Event Name</label>' +
      '<input type="text" class="lu-custom-form__name" placeholder="e.g. Desert Hearts" />' +
      '<label>Start Date</label>' +
      '<input type="date" class="lu-custom-form__start" />' +
      '<label>End Date (optional)</label>' +
      '<input type="date" class="lu-custom-form__end" />' +
      '<label>Location (optional)</label>' +
      '<input type="text" class="lu-custom-form__location" placeholder="e.g. San Diego, CA" />' +
      '<div class="lu-custom-form__actions">' +
      '<button class="lu-custom-form__btn lu-custom-form__btn--cancel" type="button">Cancel</button>' +
      '<button class="lu-custom-form__btn lu-custom-form__btn--create" type="button">Create</button>' +
      '</div>';

    form.querySelector('.lu-custom-form__btn--cancel').addEventListener('click', function () {
      form.classList.remove('open');
    });

    form.querySelector('.lu-custom-form__btn--create').addEventListener('click', function () {
      var name = form.querySelector('.lu-custom-form__name').value.trim();
      var startDate = form.querySelector('.lu-custom-form__start').value;
      var endDate = form.querySelector('.lu-custom-form__end').value || startDate;
      var location = form.querySelector('.lu-custom-form__location').value.trim();

      if (!name || !startDate) {
        showToast('Please enter a name and start date');
        return;
      }

      var slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var customFest = {
        name: name,
        slug: slug + '-custom',
        start: startDate,
        end: endDate,
        location: location,
        source: 'custom',
        guideUrl: null,
        collectionUrl: null,
        spotifyUrl: null,
        ticketUrl: null,
        orderByQuick: '',
        orderByPre: '',
      };

      var sd = new Date(startDate + 'T00:00:00');
      var qd = new Date(sd); qd.setDate(qd.getDate() - 7);
      var pd = new Date(sd); pd.setDate(pd.getDate() - 20);
      customFest.orderByQuick = qd.toISOString().split('T')[0];
      customFest.orderByPre = pd.toISOString().split('T')[0];

      var lineup = createLineup(customFest);

      trackEvent('custom_festival_created', {
        festival_name: name,
        festival_slug: customFest.slug,
        festival_date: startDate,
        festival_end_date: endDate,
        festival_location: location,
      });

      closePicker();
      if (typeof onSelect === 'function') onSelect(lineup);
      showToast('Created <span class="lu-accent">' + name + '</span> outfit lineup');
      if (drawerOpen) renderDrawer();
      updateAllSaveButtons();
    });

    // Insert form at top of list (button is in filters bar, not in list)
    listEl.insertBefore(form, listEl.firstChild);
    form.querySelector('.lu-custom-form__name').focus();
  }

  // ─── SHARING ───
  function shareLineup(lineup) {
    var text = lineup.festival.name + ' Outfit Lineup (' + lineup.items.length + ' pieces, ' + formatPrice(lineup.items.reduce(function (s, i) { return s + i.price; }, 0)) + ')';

    var handles = lineup.items.map(function (i) { return i.handle; }).join(',');
    var shareUrl = window.location.origin + '/pages/lineup?festival=' + encodeURIComponent(lineup.festival.slug) + '&items=' + encodeURIComponent(handles);

    if (navigator.share) {
      navigator.share({
        title: text,
        text: 'Check out my ' + lineup.festival.name + ' outfit plan on Freedom Rave Wear!',
        url: shareUrl,
      }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(function () {
        showToast('Link copied! Share it with your squad.');
      });
    } else {
      showToast('Share URL: ' + shareUrl);
    }

    trackEvent('lineup_shared', {
      festival: lineup.festival.slug,
      items_count: lineup.items.length,
    });
  }

  // ─── PAGE MODE (/pages/lineup) ───
  function isLineupPage() {
    return PAGE === 'page' && (CFG.templateSuffix || '') === 'lineup';
  }

  function renderPage() {
    var container = document.getElementById('lineup-page-content');
    if (!container) return;
    container.innerHTML = '';

    // Track page view with lineup count
    trackEvent('lineup_page_viewed', {
      lineup_count: (state.lineups || []).length,
      total_items: (state.lineups || []).reduce(function (s, l) { return s + (l.items || []).length; }, 0),
    });

    if (!state.lineups || !state.lineups.length) {
      renderPageEmpty(container);
      return;
    }

    state.lineups.forEach(function (lineup) {
      renderPageLineup(container, lineup);
    });
  }

  function renderPageLineup(container, lineup) {
    // Merge stored festival with latest CDN data (picks up new guide/spotify/collection URLs)
    var fest = lineup.festival;
    var fresh = FESTIVALS.find(function (f) { return f.slug === fest.slug; });
    if (fresh) {
      if (!fest.spotifyUrl && fresh.spotifyUrl) fest.spotifyUrl = fresh.spotifyUrl;
      if (!fest.guideUrl && fresh.guideUrl) fest.guideUrl = fresh.guideUrl;
      if (!fest.collectionUrl && fresh.collectionUrl) fest.collectionUrl = fresh.collectionUrl;
      if (!fest.ticketUrl && fresh.ticketUrl) fest.ticketUrl = fresh.ticketUrl;
    }
    var numDays = getFestivalDays(lineup);
    // Exclude items on skipped days from totals
    var activeItems = lineup.items.filter(function (i) {
      return !isDaySkipped(lineup, i.day || 0);
    });
    var total = activeItems.reduce(function (s, i) { return s + (i.price || 0); }, 0);

    var card = el('div', 'lu-page-card');

    // Header
    var header = el('div', 'lu-page-card__header');
    var name = el('div', 'lu-page-card__name', fest.name);
    header.appendChild(name);

    var dateRange = formatDate(fest.start);
    if (fest.end && fest.end !== fest.start) dateRange += ' \u2013 ' + formatDate(fest.end);
    var metaParts = [dateRange];
    if (fest.location) metaParts.push(fest.location);
    if (numDays > 1) metaParts.push(numDays + ' days');
    header.appendChild(el('div', 'lu-page-card__meta', metaParts.join(' \u00B7 ')));

    var deadline = fest.orderByQuick;
    var daysLeft = daysUntil(deadline);
    if (daysLeft) {
      header.appendChild(el('div', 'lu-page-card__deadline',
        'Order by ' + formatDate(deadline) + ' (' + daysLeft + ' day' + (daysLeft > 1 ? 's' : '') + ')'));
    }

    // Resource cards — storytelling mini-cards for each link
    var resourceCards = [];
    if (fest.guideUrl) resourceCards.push({
      url: fest.guideUrl, ext: false, cls: 'lu-resource-card--guide',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/><path d="M8 7h8M8 11h5"/></svg>',
      title: 'Outfit Guide',
      desc: 'See what to wear each day.'
    });
    if (fest.spotifyUrl) resourceCards.push({
      url: fest.spotifyUrl, ext: true, cls: 'lu-resource-card--spotify',
      icon: '<svg viewBox="0 0 24 24"><path fill="#1DB954" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>',
      title: 'Pregame Mix',
      desc: 'Hear the lineup before you live it.'
    });
    if (fest.collectionUrl) resourceCards.push({
      url: fest.collectionUrl, ext: false, cls: 'lu-resource-card--collection',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 2L3 7v13a2 2 0 002 2h14a2 2 0 002-2V7l-3-5H6z"/><path d="M3 7h18"/><path d="M16 11a4 4 0 01-8 0"/></svg>',
      title: 'Shop Collection',
      desc: 'Shop the full festival edit.'
    });
    if (fest.ticketUrl) resourceCards.push({
      url: fest.ticketUrl, ext: true, cls: 'lu-resource-card--tickets',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 2L21 8l-12.6 12.6a2 2 0 01-2.8 0L2.4 17.4a2 2 0 010-2.8L15 2z"/><path d="M11 6l7 7"/><path d="M9 14l-2 2"/></svg>',
      title: 'Get Tickets',
      desc: 'Secure your spot.'
    });

    if (resourceCards.length) {
      var cardsWrap = el('div', 'lu-resource-cards');
      resourceCards.forEach(function (rc) {
        var a = el('a', 'lu-resource-card ' + rc.cls);
        a.href = rc.url;
        if (rc.ext) { a.target = '_blank'; a.rel = 'noopener'; }
        a.innerHTML =
          '<div class="lu-resource-card__icon">' + rc.icon + '</div>' +
          '<div class="lu-resource-card__text">' +
          '<div class="lu-resource-card__title">' + rc.title + '</div>' +
          '<div class="lu-resource-card__desc">' + rc.desc + '</div>' +
          '</div>' +
          '<span class="lu-resource-card__arrow">\u2192</span>';
        cardsWrap.appendChild(a);
      });
      header.appendChild(cardsWrap);
    }

    card.appendChild(header);

    // Items
    if (lineup.items.length === 0) {
      var emptyItems = el('div', 'lu-page-card__empty');
      emptyItems.innerHTML = '<div class="lu-page-empty__sub">No pieces saved yet</div>' +
        '<a class="lu-page-empty__btn lu-page-empty__btn--secondary" href="' +
        (fest.collectionUrl || '/collections/best-sellers') + '">Browse Outfits</a>';
      card.appendChild(emptyItems);
    } else if (numDays > 1) {
      renderPageDayGroups(card, lineup, numDays);
    } else {
      renderPageGrid(card, lineup.items, lineup, numDays);
    }

    // Footer (uses activeItems to exclude skipped days)
    if (activeItems.length > 0) {
      var footer = el('div', 'lu-page-card__footer');
      footer.innerHTML = '<div class="lu-page-card__total">' +
        '<strong>' + activeItems.length + ' piece' + (activeItems.length > 1 ? 's' : '') + '</strong>' +
        ' \u00B7 <span class="lu-page-card__total-price">' + formatPrice(total) + '</span></div>';
      var cartBtn = el('button', 'lu-page-card__cta', 'Add All to Cart');
      cartBtn.setAttribute('type', 'button');
      cartBtn.addEventListener('click', function () {
        addItemsToCart(activeItems, cartBtn);
      });
      footer.appendChild(cartBtn);
      card.appendChild(footer);
    }

    container.appendChild(card);
  }

  function renderPageDayGroups(container, lineup, numDays) {
    var groups = {};
    for (var d = 1; d <= numDays; d++) groups[d] = [];
    groups[0] = [];

    lineup.items.forEach(function (item) {
      var day = item.day || 0;
      if (day > numDays) day = 0;
      if (!groups[day]) groups[day] = [];
      groups[day].push(item);
    });

    var isLong = numDays > 7;
    var emptyDayCount = 0;

    for (var day = 1; day <= numDays; day++) {
      var skipped = isDaySkipped(lineup, day);
      var hasItems = groups[day].length > 0;

      if (skipped) {
        // Flush empty day summary before showing skipped day
        if (isLong && emptyDayCount > 0) {
          container.appendChild(buildPageEmptyDaySummary(emptyDayCount));
          emptyDayCount = 0;
        }
        renderPageSkippedDay(container, lineup, day, groups[day]);
      } else if (hasItems) {
        if (isLong && emptyDayCount > 0) {
          container.appendChild(buildPageEmptyDaySummary(emptyDayCount));
          emptyDayCount = 0;
        }
        renderPageDaySection(container, lineup, day, groups[day]);
      } else if (isLong) {
        emptyDayCount++;
      } else {
        // Short festival — show empty day header
        var sep = buildPageDaySeparator(lineup, day, []);
        container.appendChild(sep);
        var emptyNote = el('div', '', '<span class="lu-page-day__empty">No pieces for this day yet</span>');
        container.appendChild(emptyNote);
      }
    }

    // Trailing empty day summary
    if (isLong && emptyDayCount > 0) {
      container.appendChild(buildPageEmptyDaySummary(emptyDayCount));
    }

    if (groups[0].length > 0) {
      renderPageDaySection(container, lineup, 0, groups[0]);
    }
  }

  function buildPageEmptyDaySummary(count) {
    var summary = el('div', 'lu-page-day lu-page-day--summary');
    summary.innerHTML = '<span class="lu-page-day__line"></span>' +
      '<span class="lu-page-day__stats">' + count + ' day' + (count > 1 ? 's' : '') + ' with no outfits</span>' +
      '<span class="lu-page-day__line"></span>';
    return summary;
  }

  function buildPageDaySeparator(lineup, dayNum, items) {
    var sep = el('div', 'lu-page-day');
    var labelClass = dayNum === 0 ? 'lu-page-day__label lu-page-day__label--unassigned' : 'lu-page-day__label';
    var labelText = dayNum === 0 ? 'Unassigned' : getDayLabel(lineup, dayNum);
    sep.appendChild(el('span', labelClass, labelText));
    sep.appendChild(el('span', 'lu-page-day__line'));
    if (items.length > 0) {
      var subtotal = items.reduce(function (s, i) { return s + (i.price || 0); }, 0);
      sep.appendChild(el('span', 'lu-page-day__stats',
        items.length + ' piece' + (items.length > 1 ? 's' : '') + ' \u00B7 ' + formatPrice(subtotal)));
      var dayCartBtn = el('button', 'lu-page-day__cart-btn', 'Add Day to Cart');
      dayCartBtn.setAttribute('type', 'button');
      dayCartBtn.addEventListener('click', function () {
        trackEvent('lineup_day_add_to_cart', {
          day: dayNum,
          item_count: items.length,
          total_cents: subtotal,
          festival_slug: lineup.festival ? lineup.festival.slug : '',
        });
        addItemsToCart(items, dayCartBtn);
      });
      sep.appendChild(dayCartBtn);
    }
    return sep;
  }

  function renderPageDaySection(container, lineup, dayNum, items) {
    container.appendChild(buildPageDaySeparator(lineup, dayNum, items));
    renderPageGrid(container, items, lineup, getFestivalDays(lineup));
  }

  function renderPageSkippedDay(container, lineup, dayNum, items) {
    var wrap = el('div', 'lu-page-day-skipped');
    var label = getDayLabel(lineup, dayNum);
    var countText = items.length > 0
      ? items.length + ' piece' + (items.length > 1 ? 's' : '') + ' saved'
      : '';

    wrap.innerHTML = '<span class="lu-page-day-skipped__label">' + label + '</span>' +
      '<span class="lu-page-day-skipped__line"></span>' +
      '<span class="lu-page-day-skipped__status">Not attending' +
      (countText ? ' \u00B7 ' + countText : '') + '</span>';

    var restoreBtn = el('button', 'lu-page-day-skipped__restore', 'Restore');
    restoreBtn.setAttribute('type', 'button');
    restoreBtn.addEventListener('click', function () {
      restoreDay(lineup.id, dayNum);
      renderPage();
    });
    wrap.appendChild(restoreBtn);

    container.appendChild(wrap);
  }

  function renderPageGrid(container, items, lineup, numDays) {
    var grid = el('div', 'lu-page-grid');
    items.forEach(function (item) {
      var card = el('div', 'lu-page-item');

      var link = el('a', 'lu-page-item__link');
      link.href = item.url || '/products/' + item.handle;

      var img = document.createElement('img');
      img.className = 'lu-page-item__img';
      img.src = item.image || '';
      img.alt = item.title || '';
      img.loading = 'lazy';
      link.appendChild(img);

      var info = el('div', 'lu-page-item__info');
      info.appendChild(el('div', 'lu-page-item__name', item.title || ''));
      var metaParts = [];
      if (item.size) metaParts.push('Size ' + item.size);
      metaParts.push(formatPrice(item.price || 0));
      info.appendChild(el('div', 'lu-page-item__meta', metaParts.join(' \u00B7 ')));
      link.appendChild(info);
      card.appendChild(link);

      // Remove button
      var removeBtn = el('button', 'lu-page-item__remove', '\u00D7');
      removeBtn.setAttribute('type', 'button');
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (lineup) {
          removeItem(lineup.id, item.productId);
          renderPage();
          updateAllSaveButtons();
        }
      });
      card.appendChild(removeBtn);

      grid.appendChild(card);
    });
    container.appendChild(grid);
  }

  function renderPageEmpty(container) {
    var empty = el('div', 'lu-page-empty');
    empty.innerHTML = '<div class="lu-page-empty__icon">\uD83E\uDD0D</div>' +
      '<div class="lu-page-empty__title">No saved items yet</div>' +
      '<div class="lu-page-empty__sub">Tap the heart on any item to save it. Planning for a festival? Organize your saves into outfit lineups anytime.</div>' +
      '<div class="lu-page-empty__actions">' +
      '<button class="lu-page-empty__btn lu-page-empty__btn--primary" id="lu-page-browse">Browse Festivals</button>' +
      '<a class="lu-page-empty__btn lu-page-empty__btn--secondary" href="/collections/best-sellers">Start Shopping</a>' +
      '</div>';
    container.appendChild(empty);

    var browseBtn = document.getElementById('lu-page-browse');
    if (browseBtn) {
      browseBtn.addEventListener('click', function () { openPicker(); });
    }
  }

  // ─── SHOPPING MODE INTEGRATION ───
  function autoCreateFromShoppingMode() {
    var sm = getShoppingMode();
    if (!sm || !sm.slug) return;

    var exists = state.lineups.some(function (l) { return l.festival.slug === sm.slug; });
    if (exists) return;

    var fest = FESTIVALS.find(function (f) { return f.slug === sm.slug; });
    if (!fest) return;

    window.__lineupSuggestedFestival = fest;
  }

  // ─── BOOT ───
  function init() {
    loadCdnEvents(); // async — enriches FESTIVALS with CDN club nights/events
    rebuildFuseIndex(); // build initial Fuse index from hardcoded FESTIVALS
    injectCardButtons();

    if (PAGE === 'product' && PRODUCT) {
      injectPDPSave();
    }

    injectNavIcon();
    autoCreateFromShoppingMode();

    // Re-inject on dynamic content (infinite scroll, AJAX filters)
    var observer = new MutationObserver(function (mutations) {
      var hasNewCards = mutations.some(function (m) {
        return m.addedNodes.length && Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.tagName === 'PRODUCT-CARD' || n.tagName === 'PRODUCT-CARD-LINK' ||
            (n.classList && n.classList.contains('resource-card')) ||
            (n.querySelector && n.querySelector('product-card, product-card-link, .resource-card, [data-product-id]'))
          );
        });
      });
      if (hasNewCards) {
        setTimeout(injectCardButtons, 100);
      }
    });

    // Watch all surfaces where product cards can appear
    var grids = document.querySelectorAll(
      '.collection-product-grid, .product-grid, [class*="product-grid"], ' +
      '.resource-list, [class*="resource-list"], #predictive-search-products, ' +
      '.product-recommendations, [class*="product-recommendations"], ' +
      'product-recommendations, main'
    );
    grids.forEach(function (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    });
    // Search modal loads content dynamically — observe it too
    var searchModal = document.querySelector('search-modal, [class*="predictive-search"]');
    if (searchModal) {
      observer.observe(searchModal, { childList: true, subtree: true });
    }

    document.addEventListener('cart:update', function (e) {
      var detail = e.detail || {};
      var variantId = detail.variant_id || detail.variantId;
      trackEvent('lineup_item_carted', { variant_id: variantId });
    });

    // Page mode: render full-page lineup view
    if (isLineupPage()) {
      renderPage();
    }

    // Cross-tab sync: re-render page if state changes in another tab
    window.addEventListener('storage', function (e) {
      if (e.key === STORE_KEY) {
        state = loadState();
        updateAllSaveButtons();
        if (isLineupPage()) renderPage();
      }
    });
  }

  // ─── DEFERRED START ───
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ─── PUBLIC API ───
  window.FRWLineup = {
    open: openDrawer,
    close: closeDrawer,
    openPicker: openPicker,
    getState: function () { return state; },
    getActive: getActiveLineup,
    createLineup: createLineup,
    addItem: addItem,
    removeItem: removeItem,
    moveItem: moveItem,
    isProductSaved: isProductSaved,
  };

})();
